import type { MessageKey } from './index';

// Ukrainian translations. Keys mirror ./index; TypeScript enforces completeness.
export const uk: Record<MessageKey, string> = {
  'common.cancel': 'Скасувати',
  'common.stepperHint': 'Клік — крок (Shift ×10). Затисніть і тягніть вгору чи вниз',
  'common.confirm': 'Підтвердити',
  'common.copied': 'Скопійовано',
  'common.create': 'Створити',
  'common.delete': 'Видалити',
  'renders.deleteSelected': 'Видалити вибрані ({n})',
  'renders.deleteAll': 'Видалити всі',
  'renders.selectAll': 'Вибрати всі',
  'renders.deleteTitle': 'Видалити генерацію?',
  'renders.deleteSelectedTitle': 'Видалити вибрані генерації ({n})?',
  'renders.deleteAllTitle': 'Видалити всі генерації?',
  'renders.deleteFilteredTitle': 'Видалити всі генерації за вибраними фільтрами?',
  'renders.deleteText':
    'Файли видаляться назавжди. Використані генерації в ліміті тарифу не повернуться.',
  'renders.deleted': 'Видалено: {n}',
  'renders.skippedRunning': 'Ще в роботі, не видалені: {n}',
  'batch.delete': 'Видалити запуск',
  'batch.deleteTitle': 'Видалити запуск і всі його генерації?',
  'batch.deleteText':
    'Видаляться всі зображення запуску та ZIP-архів. Використані генерації в ліміті тарифу не повернуться.',
  'automation.deleteWithRenders': 'Видалити й усі згенеровані банери',
  'err.batchRunning': 'Запуск ще триває — видалити можна після завершення.',
  'err.renderRunning': 'Генерація ще в роботі — видалити можна після завершення.',
  'audit.renders.deleted': 'Видалено генерації:',
  'common.download': 'Завантажити',
  'common.edit': 'Редагувати',
  'common.error': 'Помилка',
  'common.height': 'Висота',
  'common.width': 'Ширина',
  'common.import': 'Імпорт',
  'nav.admin': 'Адмінка',
  'billing.testMode': 'Тестовий режим суперадміна',
  'billing.testModeHint':
    'Тариф цього простору змінюється одразу, без оплати — щоб перевірити обмеження.',
  'billing.manual': 'вручну',
  'admin.title': 'Адмінка',
  'admin.description': 'Усі користувачі та простори платформи. Бачать лише суперадміни.',
  'admin.overview': 'Огляд',
  'admin.users': 'Користувачі',
  'admin.usersHint': '+{n7} за 7 днів · +{n30} за 30 днів',
  'admin.active7': 'Входили за 7 днів',
  'admin.blockedN': 'Заблоковано: {n}',
  'admin.renders30': 'Генерацій за 30 днів',
  'admin.rendersHint': 'Сьогодні {today} · помилок {failed}',
  'admin.mrr': 'MRR (підписки)',
  'admin.paying': 'Платних просторів: {n}',
  'admin.workspacesByPlan': 'Простори за тарифами · {n}',
  'admin.ai30': 'AI за 30 днів',
  'admin.aiRequests': 'запитів',
  'admin.aiCost': 'витрати на модель',
  'admin.search': 'Пошук за email або назвою',
  'admin.user': 'Користувач',
  'admin.workspaces': 'Простори',
  'admin.workspace': 'Простір',
  'admin.signedUp': 'Реєстрація',
  'admin.lastLogin': 'Останній вхід',
  'admin.sessions': 'активних сесій: {n}',
  'admin.blocked': 'заблоковано',
  'admin.block': 'Заблокувати',
  'admin.unblock': 'Розблокувати',
  'admin.blockTitle': 'Заблокувати {email}?',
  'admin.blockText':
    'Користувач вийде з усіх пристроїв і не зможе увійти, доки ви його не розблокуєте. Його простори й API-ключі працюватимуть далі.',
  'admin.blockedDone': 'Користувача заблоковано',
  'admin.unblockedDone': 'Користувача розблоковано',
  'admin.signOut': 'Вийти з усіх пристроїв',
  'admin.signedOutDone': 'Сесії завершено',
  'admin.delete': 'Видалити',
  'admin.deleteTitle': 'Видалити {email}?',
  'admin.deleteText':
    'Акаунт видаляється назавжди разом із просторами, де користувач єдиний учасник: шаблони, файли, рендери. Якщо він володіє спільним простором або має платну підписку, видалення буде відхилено.',
  'admin.deletedDone': 'Користувача видалено',
  'admin.plan': 'Тариф',
  'admin.planSet': '«{name}» тепер на тарифі {plan}',
  'admin.manual': 'вручну',
  'admin.templates': 'Шаблони',
  'admin.renders30short': 'Генерації 30д',
  'admin.storage': 'Файли',
  'admin.lastRender': 'Остання генерація',
  'admin.members': 'учасників: {n}',
  'common.back': 'Назад',
  'common.next': 'Далі',
  'legal.privacy': 'Політика конфіденційності',
  'legal.terms': 'Умови використання',
  'legal.privacyLower': 'політикою конфіденційності',
  'legal.termsLower': 'умовами використання',
  'legal.and': 'та',
  'legal.consentPrefix': 'Реєструючись, ви погоджуєтеся з',
  'legal.updated': 'Оновлено {date}',
  'legal.home': 'На головну',
  'help.title': 'Допомога й документи',
  'help.support': 'Підтримка',
  'help.apiDocs': 'Документація API',
  'help.apiDocsHint': 'Ендпоінти, параметри, приклади',
  'help.termsHint': 'Правила користування сервісом',
  'help.privacyHint': 'Які дані ми зберігаємо й навіщо',
  'preview.final': 'Чистовий рендер без водяного знака',
  'preview.watermarkHint': 'Безкоштовно: превʼю з водяним знаком не витрачає ліміт тарифу.',
  'preview.finalHint': 'Спише 1 генерацію з ліміту тарифу.',
  'billing.fPreviews': 'Безкоштовні превʼю з водяним знаком',
  'showcase.badge': 'Редактор',
  'showcase.title': 'Редактор, який сам тримає макет',
  'showcase.subtitle':
    'Не просто полотно з координатами: стеки як у Figma, розумна адаптація під будь-який розмір і точні відступи. Перемкніть розмір — це справжній рендер.',
  'showcase.render': 'Згенерувати',
  'showcase.layers': 'Шари',
  'showcase.clickHint': 'Клікніть шар або змініть розмір',
  'showcase.layer': 'Шар',
  'showcase.apiField': 'Імʼя шару = поле в API та колонка таблиці',
  'showcase.stack': 'Стек (автолейаут)',
  'showcase.resize': 'Зміна розміру',
  'showcase.resizeText':
    'Шари адаптуються за своїми привʼязками — один шаблон для всіх майданчиків.',
  'showcase.altHint': 'Alt — відступи до сусідів',
  'showcase.p1Title': 'Стеки як у Figma',
  'showcase.p1Text': 'Довгий текст з API розсуває сусідів, а не налазить на них.',
  'showcase.p2Title': 'Один шаблон — усі розміри',
  'showcase.p2Text': 'Пост, сторіс і банер з одного макета з адаптацією шарів.',
  'showcase.p3Title': 'Точні відступи',
  'showcase.p3Text': 'Привʼязки, напрямні й відстані до сусідів з Alt.',
  'showcase.p4Title': 'Готово до автоматизації',
  'showcase.p4Text': 'Кожен шар одразу доступний в API, таблицях і посиланнях.',
  'motionShowcase.badge': 'Анімація',
  'motionShowcase.title': 'Статичний банер — в анімацію одним кліком',
  'motionShowcase.subtitle':
    'Натисніть «Оживити»: заголовок, фото, ціна й кнопка самі отримають свій рух. Без таймлайну й ключових кадрів.',
  'motionShowcase.static': 'Статика',
  'motionShowcase.animated': 'Анімація',
  'motionShowcase.formats': 'MP4 · WebM · GIF',
  'motionShowcase.hint': 'Це живий рендер: перемикайте стилі',
  'motionShowcase.p1Title': 'Один клік',
  'motionShowcase.p1Text':
    'Сервіс сам розуміє, де заголовок, фото, ціна й кнопка, і задає кожному шару свою появу в порядку читання.',
  'motionShowcase.p2Title': 'Стилі під задачу',
  'motionShowcase.p2Text':
    'Плавний, енергійний, розпродаж, кінетика, елегантний та інші. Результат можна доробити вручну.',
  'motionShowcase.p3Title': 'Сотні анімованих креативів',
  'motionShowcase.p3Text':
    'Той самий шаблон із таблиці, фіда чи API віддає MP4, WebM і GIF у всіх розмірах, зокрема сторіс і Reels.',
  'previewMode.title': 'Режим превʼю',
  'previewMode.text':
    'Усі генерації простору — через API, автоматизації, посилання й редактор — ідуть з водяним знаком і не витрачають ліміт. Зручно, щоб налаштувати інтеграцію; вимкніть, коли все готово.',
  'previewMode.on': 'Режим превʼю увімкнено',
  'previewMode.off': 'Режим превʼю вимкнено',
  'previewMode.banner': 'Режим превʼю: усі генерації з водяним знаком і не витрачають ліміт.',
  'previewMode.manage': 'Вимкнути',
  'linked.masterChip': 'Набір: {n} розм.',
  'linked.sizeChip': 'Розмір набору «{name}»',
  'linked.changedN': 'змінено: {n}',
  'linked.setTitle': 'Звʼязані розміри',
  'linked.addSize': 'Додати розмір',
  'linked.addSizeHint':
    'Той самий дизайн в іншому розмірі. Правки оригіналу переносяться в усі розміри, а ручні правки розміру зберігаються',
  'linked.addSizeTileHint': 'Сторіс, пост, банер — правки переносяться',
  'linked.resetAll': 'Скинути всі зміни цього розміру',
  'linked.unlink': 'Відвʼязати від оригіналу',
  'linked.masterHint':
    'Зміни цього шаблону автоматично переносяться в усі розміри. Те, що змінили вручну в розмірі, зберігається.',
  'linked.sizeHint':
    'Правки оригіналу приходять сюди автоматично. Шари, змінені тут, позначені крапкою й не перезаписуються.',
  'linked.layerChanged': 'Змінено в цьому розмірі — правки оригіналу не перезапишуть',
  'linked.resetLayer': 'Як в оригіналі',
  'linked.changesTitle': 'Змінено в цьому розмірі',
  'linked.changesHint': 'Що цей розмір змінив відносно оригіналу, і скидання',
  'linked.selectLayer': 'Вибрати шар',
  'linked.resetLayerHint': 'Повернути шар як в оригіналі',
  'linked.resetAdded': 'Прибрати',
  'linked.resetRemoved': 'Повернути',
  'linked.changeAdded': 'є лише в цьому розмірі',
  'linked.changeRemoved': 'видалений у цьому розмірі',
  'linked.propPosition': 'положення',
  'linked.propSize': 'розмір',
  'linked.propRotation': 'поворот',
  'linked.propLayout': 'розкладка',
  'linked.propText': 'текст',
  'linked.propFont': 'шрифт',
  'linked.propColor': 'колір',
  'linked.propImage': 'зображення',
  'linked.propVisibility': 'видимість',
  'linked.propMotion': 'анімація',
  'linked.propOther': 'властивості',
  'linked.option': 'Звʼязати з оригіналом',
  'linked.optionHint':
    'Зміни оригіналу самі приходитимуть у цей розмір, а ваші правки в ньому зберігатимуться.',
  'linked.optionPaid':
    'Звʼязані розміри — на тарифах Pro і Business: правите один шаблон, оновлюються всі розміри.',
  'linked.badgeSize': 'розмір набору',
  'linked.badgeMaster': 'набір · {n}',
  'billing.fLinked': 'Звʼязані розміри',
  'quality.title': 'Перевірка якості',
  'quality.found': '{n} з {total} банерів з проблемами',
  'quality.clean': 'Перевірка якості: проблем не знайдено ({total})',
  'quality.checking': 'Перевіряємо якість у міру генерації…',
  'quality.hint':
    'Обрізаний або сильно зменшений текст, незавантажені й розмиті картинки, шари за межами полотна.',
  'quality.showIssues': 'Показати лише з проблемами',
  'quality.showAll': 'Показати всі',
  'quality.markerTitle': 'Проблем: {n}',
  'issue.text_overflow': 'текст не вміщається й обрізаний',
  'issue.text_shrunk': 'текст зменшено з {from} до {to} px, щоб вмістився',
  'issue.image_missing': 'картинка не завантажилась',
  'issue.image_lowres': 'картинку {width}×{height} розтягнуто в {upscale}× — буде розмитою',
  'issue.offcanvas': 'шар за межами полотна',
  'linked.original': 'оригінал',
  'linked.setHeader': 'Набір «{name}»',
  'linked.setCount': '{n} розм.',
  'linked.setHint': 'правки оригіналу переходять в усі розміри',
  'linked.filterAll': 'Усі',
  'linked.filterSets': 'Набори',
  'linked.filterSingles': 'Окремі',
  'linked.backToAll': 'Усі шаблони',
  'linked.allSizes': 'Усі розміри',
  'linked.allSizesHint':
    'Показати всі розміри набору поруч на одному полотні. Зміни оригіналу одразу видно в усіх розмірах',
  'linked.openSize': 'Натисніть, щоб редагувати цей розмір',
  'linked.fitAll': 'Показати всі розміри',
  'linked.fitCurrent': 'Лише відкритий розмір',
  'editor.paddingX': 'Зліва й справа',
  'editor.paddingY': 'Зверху й знизу',
  'editor.paddingSides': 'Окремо для кожної сторони',
  'editor.paddingAxes': 'По горизонталі й вертикалі',
  'editor.pad_top': 'Зверху',
  'editor.pad_right': 'Справа',
  'editor.pad_bottom': 'Знизу',
  'editor.pad_left': 'Зліва',
  'billing.status.active': 'активна',
  'billing.status.trialing': 'пробний період',
  'billing.status.past_due': 'оплата не пройшла',
  'billing.status.unpaid': 'не оплачена',
  'billing.status.canceled': 'скасована',
  'billing.status.expired': 'закінчилась',
  'billing.card': 'Картка {brand} •••• {last4}',
  'billing.graceTitle': 'Оплата не пройшла',
  'billing.graceText':
    'Оновіть спосіб оплати — інакше після {date} простір перейде з тарифу {plan} на Free.',
  'billing.unpaidTitle': 'Підписку призупинено',
  'billing.unpaidText':
    'Ми не отримали оплату, тому простір працює на тарифі Free. Оновіть картку — тариф повернеться одразу після оплати.',
  'billing.updateCard': 'Оновити спосіб оплати',
  'billing.history': 'Історія платежів',
  'billing.invoice': 'Рахунок',
  'billing.reason.initial': 'Оформлення підписки',
  'billing.reason.renewal': 'Продовження',
  'billing.reason.update': 'Зміна тарифу',
  'billing.graceBanner': 'Оплата не пройшла — тариф працює до {date}:',
  'billing.graceBannerLink': 'Оновити картку',
  'admin.prices': 'Ціни',
  'admin.pricesHint':
    'Ціни тарифів у кожній валюті. Відвідувачі бачать валюту своєї країни, а списання йде в {currency}.',
  'admin.currencyOn': 'Показувати',
  'admin.perMonth': 'за місяць',
  'admin.perYear': 'за рік',
  'admin.pricesSaved': 'Ціни збережено',
  'admin.pricesReset': 'Ціни за замовчуванням',
  'admin.chargeCurrency': 'валюта оплати',
  'billing.chargedMonth': 'Списання: {amount} на місяць',
  'billing.chargedYear': 'Списання: {amount} на рік',
  'billing.billedYearly': '{amount} при оплаті за рік',
  'err.network': 'Немає звʼязку з сервером. Перевірте інтернет і спробуйте ще раз.',
  'err.seePlans': 'Тарифи',
  'err.internal': 'Щось пішло не так на нашому боці. Спробуйте ще раз за хвилину.',
  'err.validation': 'Перевірте заповнені поля.',
  'err.notFound': 'Не знайдено — можливо, це вже видалили.',
  'err.forbidden': 'Недостатньо прав для цієї дії.',
  'err.tooLarge': 'Файл завеликий.',
  'err.rateLimited': 'Забагато запитів. Спробуйте за {seconds} с.',
  'err.signIn': 'Сесія завершилась — увійдіть ще раз.',
  'err.notMember': 'Ви не учасник цього простору.',
  'err.roleRequired': 'Потрібна роль «{role}» або вища.',
  'err.templateLimit':
    'На вашому тарифі можна до {limit} шаблонів. Перейдіть на вищий тариф, щоб створити більше.',
  'err.membersLimit':
    'На вашому тарифі можна до {limit} учасників. Перейдіть на вищий тариф, щоб запросити більше.',
  'err.automationsLimit':
    'На вашому тарифі можна до {limit} автоматизацій. Перейдіть на вищий тариф, щоб додати ще.',
  'err.customSizesLimit': 'На тарифі {plan} можна зберегти до {limit} власних розмірів.',
  'err.customSizesPlan':
    'Власні розміри недоступні на тарифі {plan}. Перейдіть на вищий тариф, щоб зберігати їх.',
  'err.rendersLimit':
    'Місячний ліміт генерацій вичерпано ({used} з {limit} на тарифі {plan}). Перейдіть на вищий тариф, щоб продовжити.',
  'err.aiLimit': 'Місячний ліміт AI-запитів вичерпано ({used} з {limit} на тарифі {plan}).',
  'err.storageLimit':
    'Сховище заповнене (ліміт {mb} МБ). Видаліть непотрібні файли або перейдіть на вищий тариф.',
  'err.batchLimit':
    'За один запуск на тарифі {plan} — до {limit} зображень (запитано {requested}).',
  'err.scaleLimit': 'Масштаб {scale}× недоступний на тарифі {plan} (максимум {max}×).',
  'err.scaleTooLarge':
    'Шаблон «{name}» можна збільшити максимум у {max}x: зображення — не більше {side} px по стороні та {mpx} Мп.',
  'err.outputTooLarge':
    'Зображення мало б {width}×{height} px, а максимум — {max} px по стороні. Зменште масштаб.',
  'err.linkedSizesPlan': 'Звʼязані розміри доступні на тарифі Pro і вище.',
  'err.customFontsPlan': 'Власні шрифти доступні на тарифі Pro і вище.',
  'err.integrationsPlan': 'Google Drive і S3 доступні на платних тарифах.',
  'err.schedulePlan': 'Запуск за розкладом доступний на тарифі Pro і вище.',
  'err.signedUrlsPlan': 'Підписані посилання на картинки доступні на платних тарифах.',
  'err.templateInvalid':
    'Шаблон пошкоджено, його не вдається зберегти. Оновіть сторінку й спробуйте знову.',
  'err.sizeRange': 'Ширина й висота — цілі числа від {min} до {max} px.',
  'err.templateConflict':
    'Шаблон змінили в іншій вкладці або колега. Оновіть сторінку, щоб отримати останню версію.',
  'err.notLinkedSize': 'Цей шаблон не звʼязаний з основним.',
  'err.layerInvalid': 'Шар «{layer}»: {detail}',
  'err.batchEmpty': 'Нема чого генерувати: немає жодного рядка.',
  'err.zipNotReady': 'Архів ще готується — зачекайте трохи.',
  'err.fileTooLarge': 'Файл завеликий: максимум {mb} МБ.',
  'err.imageType':
    'Підтримуються зображення PNG, JPG, WEBP, GIF, AVIF і SVG, відео MP4, MOV і WEBM та музика MP3, M4A, WAV, OGG і FLAC.',
  'err.imageDownload': 'Не вдалося завантажити картинку за посиланням (HTTP {status}).',
  'err.urlUnreachable': 'Посилання недоступне. Перевірте адресу — вона має бути публічною.',
  'err.noFile': 'Виберіть файл.',
  'err.fontType': 'Завантажте шрифт у форматі TTF, OTF, WOFF або WOFF2.',
  'err.fontFamilyRequired': 'Вкажіть назву шрифту.',
  'err.csvParse': 'Не вдалося прочитати CSV: {detail}',
  'err.jsonInvalid': 'За посиланням не JSON.',
  'err.jsonShape': 'JSON має бути списком обʼєктів (або {"rows": [...]}).',
  'err.sheetLink': 'Це не схоже на посилання на Google Таблицю.',
  'err.sheetPrivate':
    'Таблиця закрита. Відкрийте доступ «Усім, хто має посилання» або підключіть акаунт Google.',
  'err.sourceAccessDenied': 'Немає доступу до даних (HTTP {status}).',
  'err.sourceHttp': 'Джерело даних повернуло помилку (HTTP {status}).',
  'err.sourceEmpty': 'У джерелі даних немає рядків.',
  'err.noHeaderRow': 'У файлі немає рядка із заголовками колонок.',
  'err.apiSource':
    'Ця автоматизація отримує рядки через API — запустіть її запитом POST /v1/automations/{id}/runs.',
  'err.apiRowsRequired': 'Передайте рядки («rows») для запуску.',
  'err.templatesMissing': 'Деяких вибраних шаблонів уже немає — виберіть їх заново.',
  'err.templatesGone': 'Вибраних шаблонів більше немає — виберіть інші.',
  'err.scheduleApi': 'Автоматизацію з даними з API не можна запускати за розкладом.',
  'err.cronInvalid': 'Розклад задано неправильно.',
  'err.endpointInvalid': 'Адреса сервера: {detail}',
  'err.bucketWrite': 'Не вдалося записати в бакет: {detail}',
  'err.signupsDisabled': 'Реєстрацію на цьому сервері закрито.',
  'err.emailTaken': 'Акаунт із цим email уже є — увійдіть.',
  'err.badCredentials': 'Неправильний email або пароль.',
  'err.accountBlocked': 'Акаунт заблоковано. Напишіть у підтримку.',
  'err.resetInvalid': 'Посилання для скидання пароля недійсне або застаріле — запросіть нове.',
  'err.wrongPassword': 'Поточний пароль указано неправильно.',
  'err.googleDisabled': 'Google не підключено на цьому сервері.',
  'err.googleError': 'Google повернув помилку: {detail}',
  'err.googleNoRefresh':
    'Google не надав постійного доступу. Видаліть доступ застосунку в налаштуваннях акаунта Google і підключіть знову.',
  'err.googleNoEmail': 'В акаунта Google немає підтвердженого email.',
  'err.googleOtherAccount': 'Цей email привʼязано до іншого акаунта Google.',
  'err.ownerOnlyTransfer': 'Передати права власника може лише власник.',
  'err.lastOwner': 'У просторі має лишитися хоча б один власник.',
  'err.ownerOnlyRemoveOwner': 'Видалити власника може лише власник.',
  'err.inviteOwner': 'Запросіть як адміністратора, а права власника передайте потім.',
  'err.alreadyMember': 'Ця людина вже в просторі.',
  'err.invitationInvalid': 'Запрошення недійсне або застаріле.',
  'err.invitationOtherEmail':
    'Запрошення надіслано на {email}. Увійдіть із цим email, щоб прийняти його.',
  'err.adminOnlyRemove': 'Видаляти учасників можуть лише адміністратори.',
  'err.onlyWorkspace': 'Не можна видалити єдиний простір.',
  'err.cancelBeforeDelete': 'Спершу скасуйте підписку, потім видаліть простір.',
  'err.blockSelf': 'Не можна заблокувати себе.',
  'err.deleteSelf': 'Не можна видалити себе.',
  'err.deleteSuperadmin': 'Не можна видалити суперадміна.',
  'err.paymentsDisabled': 'Оплату на цьому сервері не підключено.',
  'err.paymentProvider': 'Платіжний сервіс повернув помилку — спробуйте ще раз.',
  'err.planNotForSale': 'Цей тариф поки не можна оформити.',
  'err.noSubscription': 'У простору ще немає підписки.',
  'err.portalUnavailable': 'Кабінет оплати зараз недоступний — спробуйте пізніше.',
  'err.cancelInPortal': 'Скасувати підписку можна в кабінеті оплати.',
  'err.planSwitchDisabled': 'Зміну тарифу без оплати вимкнено.',
  'err.pricesChargeCurrency': 'Потрібні ціни в {currency}: у цій валюті йде списання.',
  'err.aiDisabled': 'AI-функції на цьому сервері вимкнено.',
  'err.aiBusy': 'AI зараз перевантажений — спробуйте за хвилину.',
  'err.code.bad_request': 'Не вийшло — перевірте дані й спробуйте ще раз.',
  'err.code.validation_error': 'Перевірте заповнені поля.',
  'err.code.unauthorized': 'Увійдіть в акаунт.',
  'err.code.forbidden': 'Недостатньо прав для цієї дії.',
  'err.code.not_found': 'Не знайдено — можливо, це вже видалили.',
  'err.code.conflict': 'Конфлікт із поточними даними — оновіть сторінку.',
  'err.code.plan_limit': 'Недоступно на вашому тарифі.',
  'err.code.quota_exceeded': 'Ліміт тарифу вичерпано.',
  'err.code.payment_required': 'Потрібна оплата тарифу.',
  'err.code.rate_limited': 'Забагато запитів — спробуйте за хвилину.',
  'err.code.payload_too_large': 'Файл завеликий.',
  'err.code.unsupported_media_type': 'Цей тип файлу не підтримується.',
  'err.code.internal_error': 'Щось пішло не так на нашому боці. Спробуйте ще раз за хвилину.',
  'err.code.service_unavailable': 'Сервіс тимчасово недоступний — спробуйте пізніше.',
  'err.field.required': 'Заповніть поле «{field}»',
  'err.field.choose': 'Виберіть хоча б одне: «{field}»',
  'err.field.minLength': '«{field}»: мінімальна довжина — {n}',
  'err.field.maxLength': '«{field}»: максимальна довжина — {n}',
  'err.field.min': '«{field}»: не менше {n}',
  'err.field.max': '«{field}»: не більше {n}',
  'err.field.email': 'Вкажіть правильний email',
  'err.field.url': '«{field}»: вкажіть повне посилання, що починається з https://',
  'err.field.invalid': 'Перевірте поле «{field}»',
  'field.name': 'Назва',
  'field.templateIds': 'Шаблони',
  'field.dataSource.url': 'Посилання на дані',
  'field.dataSource.rows': 'Таблиця',
  'field.dataSource.columns': 'Колонки таблиці',
  'field.dataSource.sheet': 'Аркуш таблиці',
  'field.dataSource.integrationId': 'Акаунт Google',
  'field.mapping.rules.layer': 'Шар у правилі',
  'field.mapping.rules.column': 'Колонка в правилі',
  'field.mapping.rules.value': 'Значення в правилі',
  'field.output.formats': 'Формати файлів',
  'field.output.scale': 'Масштаб',
  'field.output.quality': 'Якість',
  'field.output.filenamePattern': 'Імена файлів',
  'field.destinations.url': 'URL вебхука',
  'field.destinations.folderName': 'Папка в Google Drive',
  'field.destinations.integrationId': 'Акаунт для вивантаження',
  'field.destinations.prefix': 'Папка в бакеті',
  'field.schedule.cron': 'Розклад',
  'field.schedule.timezone': 'Часовий пояс',
  'field.email': 'Email',
  'field.password': 'Пароль',
  'field.newPassword': 'Новий пароль',
  'field.currentPassword': 'Поточний пароль',
  'field.workspaceName': 'Назва простору',
  'field.width': 'Ширина',
  'field.height': 'Висота',
  'field.brief': 'Опис',
  'field.text': 'Текст',
  'field.url': 'Посилання',
  'field.bucket': 'Бакет',
  'field.region': 'Регіон',
  'field.endpoint': 'Адреса сервера (endpoint)',
  'field.publicBaseUrl': 'Публічна адреса файлів',
  'field.accessKeyId': 'Access Key ID',
  'field.secretAccessKey': 'Secret Access Key',
  'field.defaultWebhookUrl': 'Вебхук за замовчуванням',
  'field.family': 'Назва шрифту',
  'field.tags': 'Теги',
  'field.format': 'Формат',
  'field.scale': 'Масштаб',
  'field.quality': 'Якість',
  'field.modifications': 'Дані для шарів',
  'common.more': 'Ще',
  'common.name': 'Назва',
  'common.notFound': 'Не знайдено',
  'common.nothingFound': 'Нічого не знайдено',
  'common.open': 'Відкрити',
  'common.openNewTab': 'Відкрити в новій вкладці',
  'common.save': 'Зберегти',
  'common.saved': 'Збережено',
  'common.search': 'Пошук',
  'common.uploading': 'Завантаження…',
  'role.owner': 'Власник',
  'role.admin': 'Адміністратор',
  'role.editor': 'Редактор',
  'role.viewer': 'Спостерігач',
  'nav.templates': 'Шаблони',
  'nav.automations': 'Автоматизації',
  'nav.renders': 'Генерації',
  'nav.assets': 'Медіатека',
  'nav.fonts': 'Шрифти',
  'nav.api': 'API та ключі',
  'nav.integrations': 'Інтеграції',
  'nav.settings': 'Налаштування',
  'nav.billing': 'Тариф і оплата',
  'nav.developers': 'Розробникам',
  'nav.workspace': 'Простір',
  'nav.workspaces': 'Робочі простори',
  'nav.newWorkspace': 'Новий простір',
  'nav.profile': 'Профіль',
  'nav.logout': 'Вийти',
  'nav.rendersThisMonth': 'Генерації за період',
  'nav.upgrade': 'Підвищити тариф',
  'auth.google': 'Продовжити з Google',
  'auth.or': 'або',
  'auth.error.google_denied': 'Вхід через Google скасовано',
  'auth.error.google_state': 'Сесія входу застаріла, спробуйте ще раз',
  'auth.error.google_failed': 'Не вдалося увійти через Google',
  'auth.error.google_unavailable': 'Вхід через Google не налаштовано на сервері',
  'settings.setPassword': 'Встановити пароль',
  'settings.googleNoPassword':
    'Ви входите через Google. Встановіть пароль, щоб входити й за email.',
  'auth.loginTitle': 'Вхід до Bannermatic',
  'auth.loginSubtitle': 'Раді бачити вас знову',
  'auth.signupTitle': 'Створіть акаунт',
  'auth.signupSubtitle': 'Безкоштовний тариф — без картки',
  'auth.email': 'Email',
  'auth.password': 'Пароль',
  'auth.passwordHint': 'Щонайменше 8 символів',
  'auth.name': "Ім'я",
  'auth.company': 'Компанія або команда',
  'auth.companyHint': 'Назва робочого простору, її можна змінити пізніше',
  'auth.forgot': 'Забули пароль?',
  'auth.loginButton': 'Увійти',
  'auth.signupButton': 'Створити акаунт',
  'auth.noAccount': 'Немає акаунта?',
  'auth.haveAccount': 'Вже маєте акаунт?',
  'auth.signupLink': 'Зареєструватися',
  'auth.loginLink': 'Увійти',
  'auth.freePlanNote': '50 генерацій на місяць безкоштовно',
  'auth.forgotTitle': 'Відновлення пароля',
  'auth.forgotSubtitle': 'Надішлемо посилання для скидання на ваш email',
  'auth.forgotSent': 'Якщо такий акаунт існує, лист уже в дорозі. Перевірте пошту.',
  'auth.sendLink': 'Надіслати посилання',
  'auth.resetTitle': 'Новий пароль',
  'auth.newPassword': 'Новий пароль',
  'auth.resetButton': 'Зберегти пароль',
  'auth.resetDone': 'Пароль змінено, увійдіть знову',
  'invite.title': 'Запрошення до команди',
  'invite.text': 'Вас запросили до простору «{workspace}» з роллю {role}.',
  'invite.accept': 'Прийняти запрошення',
  'invite.signup': 'Створити акаунт для {email}',
  'templates.description': 'Шаблони банерів із динамічними шарами для API та автоматизацій',
  'templates.new': 'Новий шаблон',
  'templates.newTitle': 'Новий шаблон',
  'templates.untitled': 'Без назви',
  'templates.createAndEdit': 'Створити й відкрити редактор',
  'templates.customSize': 'Свій розмір',
  'templates.groupSocial': 'Соцмережі',
  'templates.groupAds': 'Медійна реклама',
  'templates.groupWeb': 'Сайт і email',
  'templates.groupVideo': 'Відео',
  'templates.groupPrint': 'Друк',
  'templates.count': '{n} шт.',
  'templates.emptyTitle': 'Створіть перший шаблон',
  'templates.emptyText':
    'Зберіть банер у редакторі, дайте шарам зрозумілі імена — і генеруйте сотні варіантів через API або таблицю.',
  'templates.duplicateAs': 'Копія в іншому розмірі',
  'templates.duplicateAsHint':
    "Шари адаптуються за своїми прив'язками — потім перевірте композицію.",
  'templates.duplicated': 'Копію створено',
  'sizes.mine': 'Ваші розміри',
  'sizes.standard': 'Стандартні',
  'sizes.save': 'Зберегти розмір',
  'sizes.saved': 'Розмір збережено в робочому просторі',
  'sizes.paid': 'Власні розміри для будь-яких майданчиків — на тарифах від Starter',
  'sizes.limit': 'На вашому тарифі — до {n} власних розмірів',
  'sizes.namePlaceholder': 'Назва, напр. «Екран у лобі»',
  'billing.fSizes': 'Власних розмірів: до {n}',
  'billing.fSizesUnlimited': 'Безліміт власних розмірів',
  'templates.copyName': '{name} (копія)',
  'duplicate.menu': 'Дублювати…',
  'duplicate.title': 'Дублювати шаблон',
  'duplicate.sameSize': 'Той самий розмір {size}',
  'duplicate.otherSize': 'Інший розмір + автолейаут',
  'templates.exportJson': 'Експорт у JSON',
  'templates.importTitle': 'Імпорт шаблону',
  'templates.importHint':
    'SVG з Figma (Copy as SVG або Export → SVG), файли .json з Bannermatic або експорт Placid — можна кілька одразу',
  'templates.dropJson': 'Перетягніть файли або натисніть, щоб вибрати',
  'templates.figmaTitle': 'Як експортувати з Figma',
  'templates.figmaStep1': 'Виділіть фрейм банера (Frame, не групу).',
  'templates.figmaStep2': 'Справа внизу в Export натисніть «+» і виберіть формат SVG.',
  'templates.figmaStep3':
    'Натисніть «…» біля SVG і зніміть «Outline text» — тоді тексти лишаться текстами.',
  'templates.figmaStep4': 'Натисніть Export і перетягніть файл .svg сюди.',
  'templates.figmaNote':
    'Швидше: ПКМ по фрейму → Copy/Paste as → Copy as SVG і Ctrl+V (⌘V) тут, але тексти тоді прийдуть кривими. Шрифти, яких немає в «Шрифтах», заміняться схожими й підсвітяться — завантажте їх, щоб було один в один.',
  'templates.svg.fontsReplaced':
    'Немає шрифтів із макета, тимчасово замінено: {fonts}. Такі тексти підсвічено в редакторі — завантажте шрифти, і вони застосуються одним кліком.',
  'templates.svg.uploadFonts': 'Завантажити шрифти',
  'templates.svg.outlined':
    'Тексти в цьому SVG перетворено на криві — їх не можна редагувати. У Figma: Export → SVG → «…» → зніміть «Outline text» та імпортуйте знову. Або виділіть таке зображення в редакторі → «Це текст?».',
  'editor.missingFontTitle': 'Шрифт «{font}» не завантажено',
  'editor.missingFontText':
    'Текст показано шрифтом {used} — так він вийде й у рендері. Завантажте шрифт на сторінці «Шрифти», і тут з’явиться кнопка «Застосувати».',
  'editor.missingFontFound': 'Шрифт {font} уже є в просторі.',
  'editor.missingFontApply': 'Застосувати {font}',
  'editor.missingFontUpload': 'Завантажити шрифт',
  'editor.missingFontKeep': 'Залишити {used}',
  'editor.fontNotInWorkspace':
    'Такого шрифту немає в просторі. У редакторі він може показуватися зі шрифтів вашого комп’ютера, але в генерації текст буде іншим шрифтом. Завантажте файл шрифту або виберіть інший.',
  'editor.textFromImageTitle': 'Це текст?',
  'editor.textFromImageHint':
    'Figma часто експортує тексти кривими. Зробіть із цього зображення редагований текст на тому ж місці.',
  'editor.textFromImageManual': 'Замінити текстовим шаром',
  'editor.textFromImagePlaceholder': 'Текст',
  'templates.importButton': 'Імпорт: Figma, JSON',
  'templates.importing': 'Імпортую… Зображення завантажуються в медіатеку',
  'templates.importFormats': 'SVG з Figma · .json Bannermatic · експорт Placid',

  'templates.svg.invalid': 'Не вдалося прочитати SVG. Експортуйте фрейм із Figma як SVG',
  'templates.svg.empty': 'У SVG не знайдено шарів',
  'templates.svg.tooMany': 'В SVG понад 500 шарів — спростіть макет',
  'templates.imported': 'Шаблон імпортовано',
  'templates.deleteTitle': 'Видалити шаблон?',
  'templates.deleteText': 'Шаблон «{name}» стане недоступним в API та автоматизаціях.',
  'gallery.open': 'Бібліотека шаблонів',
  'gallery.title': 'Бібліотека шаблонів',
  'gallery.description':
    'Готові макети на стеках: підставте свої тексти й картинки або змініть розмір — верстка підлаштується.',
  'gallery.all': 'Усі',
  'gallery.use': 'Використати',
  'gallery.created': 'Шаблон створено',
  'gallery.fromLibrary': 'Або почніть із готового шаблону з бібліотеки',
  'gallery.cat.sale': 'Розпродажі',
  'gallery.cat.ecommerce': 'Товари',
  'gallery.cat.event': 'Події',
  'gallery.cat.social': 'Соцмережі',
  'gallery.cat.food': 'Їжа й кафе',
  'gallery.cat.realestate': 'Нерухомість',
  'gallery.cat.education': 'Навчання',
  'gallery.cat.hiring': 'Вакансії',
  'gallery.cat.travel': 'Подорожі',
  'gallery.cat.fitness': 'Спорт',
  'gallery.cat.holiday': 'Свята',
  'gallery.cat.ads': 'Веб-банери',
  'gallery.cat.beauty': 'Краса',
  'gallery.cat.auto': 'Авто',
  'gallery.cat.tech': 'Технології',
  'gallery.cat.pets': 'Улюбленці',
  'ai.create': 'Створити з AI',
  'ai.regenerate': 'Ще варіанти',
  'ai.credits': 'AI-запитів: {used} з {limit} цього місяця',
  'ai.disabled': 'AI-генерацію не налаштовано на сервері (GEMINI_API_KEY).',
  'aiVideo.title': 'Відео за описом',
  'aiVideo.placeholder': 'Наприклад: запуск застосунку Nova для монтажу, на 48% швидше, темна тема',
  'aiVideo.generate': 'Створити відео',
  'aiVideo.generating': 'AI режисує варіанти…',
  'aiVideo.style_launch': 'Запуск продукту',
  'aiVideo.style_showreel': 'Шоурил',
  'aiVideo.style_manifesto': 'Маніфест',
  'aiVideo.style_data': 'Історія в цифрах',
  'aiVideo.style_brand': 'Бренд-фільм',
  'director.title': 'AI-режисер',
  'director.description':
    'Опишіть, що потрібно і для чого. Агент сам збере ролик або банер інструментами редактора: сцени, тексти й шрифти, фото, моушн-графіку, текстові ефекти, переходи, камеру й музику. Далі все редагується як звичайний шаблон.',
  'director.video': 'Ролик',
  'director.banner': 'Банер',
  'director.placeholderVideo':
    'Наприклад: ролик-запуск застосунку Nova для монтажу відео. Аудиторія — блогери. Головне: монтаж на 48% швидший. Енергійно, темний стиль з помаранчевим, наприкінці «Завантажити безкоштовно».',
  'director.placeholderBanner':
    'Наприклад: банер літнього розпродажу кросівок RUNNER, знижка 30% до неділі, яскравий і спортивний, кнопка «Купити».',
  'director.run': 'Створити',
  'director.again': 'Ще варіант',
  'director.open': 'Відкрити в редакторі',
  'director.mockNote': 'Тестовий режим без ключа API: агент відтворює заготовлений сценарій.',
  'director.logHint': 'Тут буде видно, як агент збирає роботу: крок за кроком.',
  'director.thinking': 'Агент продумує ідею й розкадровку…',
  'director.working': 'Агент працює · крок {n}',
  'director.fixed': 'Агент виправив помилок по ходу: {n}',
  'director.previewHint': 'Тут з’явиться результат',
  'director.tool_plan_style': 'Стиль',
  'director.tool_add_scene': 'Сцена',
  'director.tool_add_text': 'Текст',
  'director.tool_add_shape': 'Фігура',
  'director.tool_add_photo': 'Фото',
  'director.tool_add_graphic': 'Графіка',
  'director.tool_add_camera': 'Камера',
  'director.tool_set_music': 'Музика',
  'director.tool_finish': 'Готово',
  'director.tool_add_logo': 'Логотип',
  'director.tool_update': 'Правка',
  'director.tool_remove': 'Видалення',
  'director.tool_update_scene': 'Сцена: правка',
  'director.tool_review': 'Перевірка',
  'director.reviewFound': 'зауважень: {n} — виправляю',
  'director.reviewClean': 'зауважень немає',
  'director.brandDefault': 'Бренд: {name}',
  'director.brandNone': 'Без бренду',
  'director.brandHint':
    'Кольори, шрифти й логотип бренд-кіту: ролик залишиться пов’язаним із брендом',
  'dictation.start': 'Диктувати',
  'dictation.stop': 'Зупинити диктування',
  'dictation.listening': 'Слухаю…',
  'dictation.lang': 'Мова диктування',
  'dictation.denied': 'Немає доступу до мікрофона — дозвольте його в браузері',
  'dictation.failed': 'Не вдалося розпізнати мовлення',
  'ai.copyVariants': 'AI-варіанти тексту',
  'ai.copyHint': 'Клік — підставити варіант. Скасувати — Ctrl+Z.',
  'billing.fAi': 'AI-запитів на місяць: {n}',
  'billing.aiPeriod': 'AI-запити в поточному періоді',
  'editor.dropImages': 'Відпустіть, щоб завантажити файли',
  'editor.saved': 'Збережено',
  'editor.unsaved': 'Є зміни',
  'editor.saving': 'Збереження…',
  'editor.saveError': 'Помилка збереження',
  'editor.conflict': 'Конфлікт версій',
  'editor.conflictTitle': 'Шаблон змінено в іншому місці',
  'editor.conflictText':
    'Хтось зберіг шаблон, поки ви редагували. Перезаписати своєю версією? «Скасувати» завантажить актуальну версію.',
  'editor.overwrite': 'Перезаписати',
  'editor.undo': 'Скасувати',
  'editor.redo': 'Повторити',
  'editor.zoomIn': 'Наблизити',
  'editor.zoomOut': 'Віддалити',
  'editor.zoomFit': 'За розміром екрана',
  'editor.zoom100': 'Масштаб 100%',
  'editor.selectAll': 'Вибрати всі шари',
  'editor.rename': 'Перейменувати',
  'editor.resize': 'Розмір',
  'editor.testRender': 'Згенерувати',
  'editor.readOnly': 'У вас доступ лише для перегляду.',
  'editor.tabElements': 'Елементи',
  'editor.tabMedia': 'Медіа',
  'editor.tabLayers': 'Шари',
  'editor.text': 'Текст',
  'editor.addHeading': 'Заголовок',
  'editor.addSubheading': 'Підзаголовок',
  'editor.addBody': 'Основний текст',
  'editor.presetHeading': 'Заголовок',
  'editor.presetSubheading': 'Підзаголовок',
  'editor.presetBody': 'Основний текст. Подвійний клік, щоб змінити.',
  'editor.addBadge': 'Плашка −30%',
  'editor.shapes': 'Фігури',
  'editor.shapeRectangle': 'Прямокутник',
  'editor.shapeRounded': 'Заокруглений',
  'editor.shapeEllipse': 'Еліпс',
  'editor.shapeTriangle': 'Трикутник',
  'editor.shapeLine': 'Лінія',
  'editor.shapeDiamond': 'Ромб',
  'editor.shapePolygon': 'Багатокутник',
  'editor.shapeStar': 'Зірка',
  'editor.shapeBurst': 'Вибух',
  'editor.shapeHeart': 'Серце',
  'editor.shapeArrow': 'Стрілка',
  'editor.shapeChevron': 'Шеврон',
  'editor.shapeCross': 'Плюс',
  'editor.shapeBubble': 'Хмаринка',
  'editor.shapeRibbon': 'Стрічка',
  'editor.shapeTag': 'Цінник',
  'editor.shapeParallelogram': 'Паралелограм',
  'editor.shapeSemicircle': 'Півколо',
  'editor.shapeBlob': 'Пляма',
  'editor.shapeIcon': 'Іконка',
  'editor.shapePoints': 'Промені',
  'editor.shapeSides': 'Сторони',
  'editor.shapeInner': 'Глибина',
  'editor.secTextStyles': 'Стилі тексту',
  'editor.secStickers': 'Стікери та бейджі',
  'editor.secIcons': 'Іконки',
  'editor.secInfo': 'Контакти та інфо',
  'editor.secDecor': 'Рамки та декор',
  'editor.secOverlays': 'Фони та затемнення',
  'editor.iconSearch': 'Пошук: phone, gift, star…',
  'editor.noIcons': 'Нічого не знайдено',
  'editor.showAllIcons': 'Показати всі ({n})',
  'editor.showLess': 'Згорнути',
  'editor.elCta': 'Кнопка',
  'editor.txtCta': 'Купити зараз',
  'editor.elKicker': 'Надзаголовок',
  'editor.txtKicker': 'Новинка сезону',
  'editor.elHighlight': 'Маркер',
  'editor.txtHighlight': 'Лише сьогодні',
  'editor.elOutline': 'Контур',
  'editor.elNeon': 'Неон',
  'editor.txtNeon': 'Відчинено',
  'editor.elScript': 'Рукописний',
  'editor.txtScript': 'З любов’ю',
  'editor.elElegant': 'Елегантний',
  'editor.elPoster': 'Афіша',
  'editor.elQuote': 'Цитата',
  'editor.txtQuote': '«Найкраща кава в місті!»',
  'editor.elPrice': 'Ціна зі знижкою',
  'editor.elFineprint': 'Виноска',
  'editor.txtFineprint': '*Пропозиція діє до 31 грудня',
  'editor.elSale': 'Розпродаж',
  'editor.txtSale': 'SALE',
  'editor.elDiscount': 'Знижка',
  'editor.elNew': 'Новинка',
  'editor.txtNew': 'NEW',
  'editor.elRibbon': 'Стрічка',
  'editor.txtRibbon': 'ХІТ ПРОДАЖІВ',
  'editor.elTag': 'Цінник',
  'editor.elBubble': 'Репліка',
  'editor.txtBubble': 'Вау!',
  'editor.elLove': 'Серце',
  'editor.elShipping': 'Доставка',
  'editor.txtShipping': 'Безкоштовна доставка',
  'editor.elRating': 'Рейтинг',
  'editor.elTimer': 'Таймер',
  'editor.elPhone': 'Телефон',
  'editor.elAddress': 'Адреса',
  'editor.txtAddress': 'вул. Центральна, 1',
  'editor.elWebsite': 'Сайт',
  'editor.elDate': 'Дата',
  'editor.txtDate': '12 травня · 19:00',
  'editor.elSocial': 'Соцмережа',
  'editor.elChecklist': 'Список',
  'editor.txtChecklist': 'Перевага {n}',
  'editor.elFrame': 'Рамка',
  'editor.elDashedFrame': 'Пунктир',
  'editor.elRing': 'Кільце',
  'editor.elDivider': 'Акцент',
  'editor.elDottedLine': 'Крапки',
  'editor.elCircles': 'Кола',
  'editor.elBlob': 'Пляма',
  'editor.elShadeBottom': 'Тінь знизу',
  'editor.elShadeTop': 'Тінь зверху',
  'editor.elShadeLeft': 'Тінь зліва',
  'editor.elVignette': 'Віньєтка',
  'editor.elTint': 'Тонування',
  'editor.elDuotone': 'Дуотон',
  'editor.elHalfPanel': 'Половина',
  'editor.elDiagonal': 'Діагональ',
  'editor.elArc': 'Дуга знизу',
  'editor.stockPhotos': 'Фото',
  'editor.stockHint':
    'Royalty-free фото: можна використовувати в комерційних банерах без зазначення автора. Клік — вставити або замінити виділене зображення.',
  'editor.photoTag.all': 'Усі',
  'editor.photoTag.people': 'Люди',
  'editor.photoTag.beauty': 'Краса',
  'editor.photoTag.food': 'Їжа',
  'editor.photoTag.travel': 'Подорожі',
  'editor.photoTag.home': 'Дім',
  'editor.photoTag.business': 'Бізнес',
  'editor.photoTag.sport': 'Спорт',
  'editor.photoTag.holiday': 'Свята',
  'editor.photoTag.auto': 'Авто',
  'editor.photoTag.pets': 'Улюбленці',
  'editor.photoTag.nature': 'Природа',
  'editor.dynamic': 'Динамічні',
  'editor.imagePlaceholder': 'Фото / логотип',
  'editor.qr': 'QR-код',
  'editor.dynamicHint':
    'Будь-який шар можна змінювати через API за його іменем: текст, картинку, колір, позицію.',
  'editor.noLayers': 'Шарів поки немає. Додайте текст, фігуру або зображення.',
  'editor.uploadImages': 'Завантажити фото або відео',
  'editor.uploadNew': 'Завантажити нове',
  'editor.mediaHint':
    'Клік — вставити на полотно або замінити картинку виділеного шару. Файли можна просто перетягнути на полотно.',
  'editor.noUploads': 'Завантажень поки немає',
  'editor.removeImage': 'Прибрати зображення',
  'editor.placeholderImage': 'Плейсхолдер — картинку передадуть через API',
  'editor.replaceImage': 'Замінити фото або відео',
  'editor.dropToReplace': 'Відпустіть, щоб замінити',
  'editor.chooseImage': 'Вибрати фото або відео',
  'editor.imageUrl': 'або вставте URL картинки',
  'editor.template': 'Шаблон',
  'editor.canvasSize': 'Розмір полотна',
  'editor.customSize': 'Свій розмір',
  'editor.resizeHint':
    "З адаптацією шари підлаштуються під новий розмір за своїми прив'язками. Скасувати — Ctrl+Z.",
  'editor.background': 'Фон',
  'editor.transparentHint': 'Прозорий фон збережеться в PNG і WEBP.',
  'editor.tips': 'Підказки',
  'editor.tipNames':
    'Дайте шарам зрозумілі імена (title, photo, price) — за ними дані підставляються через API та таблиці.',
  'editor.tipShortcuts':
    'Ctrl+Z / Ctrl+Shift+Z, Ctrl+D — дубль, стрілки — зсув (Shift ×10), коліщатко + Ctrl — масштаб, пробіл — переміщення полотна, Alt — відстані до сусідів.',
  'editor.tipTools':
    'Інструменти: R — прямокутник, U — заокруглений, O — еліпс, L — лінія, T — текст, H — заголовок (Shift+H — підзаголовок), B — плашка, I — фото, Q — QR. Протягніть по полотну або клацніть; V чи Esc — вибір.',
  'editor.toolHint': '{tool}: протягніть по полотну або клацніть · Esc — скасувати',
  'editor.tipDrop': 'Перетягніть зображення просто на полотно — вони завантажаться в медіатеку.',
  'editor.nameInvalid': "Ім'я не може містити . = & ? # / \\",
  'editor.nameTaken': "Таке ім'я вже є в шаблоні",
  'editor.layerNameHint': "Ім'я шару — ключ в API та колонка в таблиці",
  'editor.layerDescription': "Опис для API (необов'язково)",
  'editor.position': 'Положення і розмір',
  'editor.constraints': "Прив'язка при зміні розміру",
  'editor.constraintsHint': 'Як шар підлаштовується, коли змінюється розмір шаблону.',
  'editor.cH': 'По горизонталі',
  'editor.cV': 'По вертикалі',
  'editor.c.auto': 'Авто',
  'editor.c.left': 'Зліва',
  'editor.c.right': 'Справа',
  'editor.c.top': 'Зверху',
  'editor.c.bottom': 'Знизу',
  'editor.c.center': 'По центру',
  'editor.c.stretch': 'Розтягнути',
  'editor.c.scale': 'Масштабувати',
  'editor.c.proportional': 'пропорційно',
  'editor.adaptLayers': 'Адаптувати шари',
  'editor.applySize': 'Застосувати розмір',
  'resize.preview': 'Попередній перегляд',
  'resize.extremeWarning': 'Пропорції сильно змінюються — перевірте композицію після копіювання.',
  'editor.stack': 'Стек',
  'editor.stackExpand': 'Показати шари стеку',
  'editor.stackCollapse': 'Згорнути стек',
  'editor.groupStack': 'У стек',
  'editor.ungroupStack': 'Розгрупувати',
  'editor.stackLayout': 'Авто-розкладка',
  'editor.dirVertical': 'Колонка',
  'editor.dirHorizontal': 'Рядок',
  'editor.dirAuto': 'Авто',
  'editor.dirFree': 'Немає',
  'editor.dirFreeHint':
    'Без авто-розкладки: шари лежать там, де ви їх поставили (текст на кнопці), і рухаються разом зі стеком. Колонка або рядок вишикує їх автоматично.',
  'editor.dirAutoHint':
    'Авто: рядок, коли полотно ширше за висоту в N разів і більше, інакше колонка. Так один макет підходить і для горизонтальних, і для вертикальних розмірів.',
  'editor.autoRowRatio': 'Рядок від N : 1',
  'editor.gap': 'Проміжок',
  'editor.alignItems': 'Вирівнювання',
  'editor.al.start': 'Початок',
  'editor.al.center': 'Центр',
  'editor.al.end': 'Кінець',
  'editor.al.stretch': 'Розтягнути',
  'editor.distribution': 'Розподіл',
  'editor.js.start': 'На початку',
  'editor.js.center': 'По центру',
  'editor.js.end': 'У кінці',
  'editor.js.space-between': 'Між',
  'editor.clip': 'Обрізати вміст',
  'editor.inStack': 'У стеку «{name}»',
  'editor.selectStack': 'Вибрати стек',
  'editor.grow': 'Заповнювати вільне місце',
  'editor.earlier': 'Раніше',
  'editor.later': 'Пізніше',
  'editor.stackHint':
    'Шари всередині стека розкладаються автоматично: довгий текст відсуває наступні елементи.',
  'editor.stackFeatText': 'Текст став довшим — сусідні шари самі зсуваються',
  'editor.stackFeatGrow':
    'Шар може зайняти вільне місце: у шару ввімкніть «Заповнювати вільне місце»',
  'editor.stackFeatAuto': '«Авто»: рядок у широких розмірах, колонка у високих',
  'editor.groupHint': 'Ctrl+G — зібрати виділене в стек, Ctrl+Shift+G — розгрупувати.',
  'editor.copy': 'Копіювати',
  'editor.paste': 'Вставити',
  'editor.alignToPage': 'Вирівняти по сторінці',
  'editor.alignSelection': 'Вирівняти',
  'editor.order': 'Порядок',
  'editor.setAsBackground': 'Зробити фоном',
  'editor.editText': 'Редагувати текст',
  'editor.moreActions': 'Ще дії',
  'editor.opacityShort': 'Прозор.',
  'editor.alignLeft': 'По лівому краю',
  'editor.alignHCenter': 'По центру',
  'editor.alignRight': 'По правому краю',
  'editor.alignTop': 'По верху',
  'editor.alignVCenter': 'По середині',
  'editor.alignBottom': 'По низу',
  'editor.justify': 'По ширині',
  'editor.distributeH': 'Розподілити по горизонталі',
  'editor.distributeV': 'Розподілити по вертикалі',
  'editor.arrange': 'Шар',
  'editor.bringFront': 'На передній план',
  'editor.bringForward': 'Вище',
  'editor.sendBackward': 'Нижче',
  'editor.sendBack': 'На задній план',
  'editor.lock': 'Закріпити',
  'editor.unlock': 'Відкріпити',
  'editor.hide': 'Сховати',
  'editor.show': 'Показати',
  'editor.duplicate': 'Дублювати',
  'editor.layersSelected': 'Вибрано шарів: {n}',
  'editor.clearSelection': 'Зняти виділення',
  'editor.typography': 'Шрифт',
  'editor.italic': 'Курсив',
  'editor.lineHeight': 'Міжрядковий інтервал',
  'editor.lineHeightShort': '↕',
  'editor.letterSpacing': 'Міжлітерний інтервал',
  'editor.letterSpacingShort': '↔',
  'editor.transformNone': 'Як є',
  'editor.uppercase': 'ВЕЛИКІ',
  'editor.lowercase': 'малі',
  'editor.capitalize': 'Кожне Слово',
  'editor.dynamicText': 'Довгий текст',
  'editor.autoFit': 'Зменшувати шрифт, щоб текст вміщався',
  'editor.minFontSize': 'Мін. розмір',
  'editor.maxLines': 'Макс. рядків',
  'editor.autoFitHint':
    'Знадобиться, коли текст приходить з API: короткий залишиться великим, довгий акуратно зменшиться. 0 рядків — без обмеження.',
  'editor.textBox': 'Плашка тексту',
  'editor.padding': 'Внутрішні відступи',
  'editor.radius': 'Заокруглення',
  'editor.effects': 'Ефекти',
  'editor.stroke': 'Обведення',
  'editor.shadow': 'Тінь',
  'editor.blurShort': 'Blur',
  'editor.image': 'Зображення або відео',
  'editor.fitCover': 'Заповнити',
  'editor.fitContain': 'Вписати',
  'editor.fitFill': 'Розтягнути',
  'editor.focusX': 'Фокус X',
  'editor.focusY': 'Фокус Y',
  'editor.videoClip': 'Відео',
  'editor.videoClipHint':
    'Ролик {s} с грає в анімації та відеорендері; у картинках видно його перший кадр.',
  'editor.videoLoop': 'Повторювати по колу',
  'editor.videoSound': 'Зі звуком',
  'editor.videoVolume': 'Гучність',
  'editor.videoTrim': 'Фрагмент кліпу',
  'editor.videoRemove': 'Залишити тільки кадр',
  'editor.videoPlay': 'Переглянути відео',
  'editor.videoPause': 'Зупинити перегляд',
  'editor.videoMute': 'Вимкнути звук',
  'editor.videoUnmute': 'Увімкнути звук',
  'err.videoUnreadable': 'Не вдалося прочитати відео: завантажте MP4, MOV або WEBM.',
  'editor.imageApiHint':
    'Через API передайте URL: {"photo": "https://…"}. Фото обріжеться за фокусом.',
  'editor.style': 'Оформлення',
  'editor.border': 'Рамка',
  'editor.brightness': 'Яскравість',
  'editor.blur': 'Розмиття',
  'editor.grayscale': 'Ч/Б',
  'editor.flipX': 'Віддзеркалити по горизонталі',
  'editor.flipY': 'Віддзеркалити по вертикалі',
  'editor.shape': 'Фігура',
  'editor.line': 'Лінія',
  'editor.width': 'Товщина',
  'editor.strokeSolid': 'Суцільна',
  'editor.strokeDashed': 'Штрих',
  'editor.strokeDotted': 'Крапки',
  'editor.qrColor': 'Колір',
  'editor.qrMargin': 'Поля',
  'editor.qrLevel': 'Корекція',
  'editor.pickColor': 'Вибрати колір',
  'editor.docColors': 'Кольори шаблону',
  'fold.autoFit': 'підгонка шрифту',
  'fold.maxLines': 'до {n} рядків',
  'fold.words': 'слів: {n}',
  'fold.numbers': 'цифри',
  'accent.bar': 'Акцент',
  'accent.bold': 'Жирніше',
  'accent.underline': 'Підкреслити',
  'accent.marker': 'Маркер',
  'accent.markerOn': 'Додати маркер',
  'accent.markerOff': 'Прибрати маркер',
  'accent.remove': 'Прибрати акцент',
  'accent.more': 'Свій колір, маркер, розмір…',
  'accent.textColor': 'Текст',
  'accent.size': 'Розмір',
  'accent.wordTitle': 'Акцент «{word}»',
  'accent.dragHint': 'Перетягніть, щоб бачити всю композицію',
  'accent.title': 'Акценти в тексті',
  'accent.hint':
    'Подвійний клік по тексту, виділіть слово й виберіть колір над ним — або додайте слово тут. Слово виділяється в будь-якому тексті, де воно є, і в даних з таблиці теж.',
  'accent.wordPlaceholder': 'Слово або фраза',
  'accent.add': 'Додати',
  'accent.dataTitle': 'Акцент із даних',
  'accent.numbers': 'Цифри й відсотки акцентом',
  'accent.dataHint':
    'У таблиці чи API: **слово** в тексті клітинки, або колонка «{layer}.accent» зі словом (кілька — через «;»), або «{layer}.accent_color» з кольором.',
  'editor.colorOpacity': 'Непрозорість',
  'editor.fillNone': 'Немає',
  'editor.fillSolid': 'Колір',
  'editor.fillLinear': 'Лінійний',
  'editor.fillRadial': 'Радіальний',
  'editor.angle': 'Кут',
  'editor.addStop': 'Додати колір',
  'editor.searchFonts': 'Знайти шрифт',
  'editor.manageFonts': 'Керування шрифтами та завантаження своїх',
  'editor.weight100': 'Thin',
  'editor.weight200': 'ExtraLight',
  'editor.weight300': 'Light',
  'editor.weight400': 'Regular',
  'editor.weight500': 'Medium',
  'editor.weight600': 'SemiBold',
  'editor.weight700': 'Bold',
  'editor.weight800': 'ExtraBold',
  'editor.weight900': 'Black',
  'preview.title': 'Генерація',
  'preview.description': 'Підставте дані й подивіться результат таким, яким його поверне API.',
  'preview.formatImage': 'Картинка',
  'preview.formatVideo': 'Відео',
  'preview.deviceHint':
    'Відео створюється на цьому компʼютері. Не закривайте вкладку, доки рендер не завершиться.',
  'preview.noFields': 'У шаблоні немає шарів для підстановки.',
  'preview.render': 'Згенерувати',
  'preview.rendering': 'Рендеримо…',
  'preview.empty': "Тут з'явиться результат",
  'preview.openPdf': 'Відкрити PDF',
  'apiDialog.title': 'Генерація через API',
  'apiDialog.description': 'Шари цього шаблону та готові приклади запитів',
  'apiDialog.reference': 'Повна документація API',
  'apiDialog.layer': 'Шар',
  'apiDialog.type': 'Тип',
  'apiDialog.properties': 'Властивості',
  'apiDialog.hint':
    'Ключ API створюється в розділі «API та ключі». Замість об\'єкта можна передати рядок: "title": "Текст" або "photo": "https://…".',
  'resize.title': 'Копія в іншому розмірі',
  'resize.description': 'Створимо копію шаблону й адаптуємо шари під новий розмір',
  'resize.preset': 'Готові розміри',
  'resize.choosePreset': 'Виберіть розмір…',
  'resize.hint':
    'Шаблони різних розмірів з однаковими іменами шарів можна генерувати одним запуском автоматизації.',
  'resize.limitHint': 'Шаблонів на вашому тарифі: до {n}.',
  'resize.createCopy': 'Створити копію',
  'resize.created': 'Копію створено',
  'automations.description':
    'Масова генерація: таблиця даних × шаблони → готові файли в ZIP, Google Drive, S3 або вебхук',
  'automations.new': 'Нова автоматизація',
  'automations.emptyTitle': 'Автоматизацій поки немає',
  'automations.emptyText':
    'Завантажте CSV або підключіть Google Таблицю, виберіть шаблони — і отримайте сотні креативів одним кліком або за розкладом.',
  'automations.disabled': 'Вимкнена',
  'automations.neverRun': 'Ще не запускалася',
  'automations.runNow': 'Запустити',
  'automations.howTitle': 'Як це працює',
  'automations.how1':
    'Виберіть один або кілька шаблонів (наприклад, квадрат, сторіс і банер 728×90).',
  'automations.how2': 'Підключіть дані: CSV, Google Таблиця, URL з JSON/CSV або рядки через API.',
  'automations.how3':
    'Зіставте колонки з шарами — колонки з іменами шарів підставляться автоматично.',
  'automations.how4':
    'Виберіть формати й куди надіслати результат. Запускайте вручну, за розкладом або з API.',
  'automations.source.table': 'Таблиця / CSV',
  'automations.source.google_sheets': 'Google Таблиця',
  'automations.source.url': 'URL (CSV/JSON/XML)',
  'automations.source.api': 'Рядки через API',
  'automation.namePlaceholder': 'Назва автоматизації, наприклад «Картки товарів»',
  'automation.enabled': 'Увімкнена',
  'automation.fold': 'Згорнути',
  'automation.unfold': 'Розгорнути',
  'automation.pickTemplates': 'Вибрати шаблони ({n})',
  'automation.changeTemplates': 'Змінити вибір',
  'automation.searchTemplates': 'Пошук шаблону',
  'automation.pickDone': 'Готово — далі дані',
  'automation.sumTemplates': 'Вибрано: {n}',
  'automation.sumNoTemplates': 'Шаблони не вибрано',
  'automation.sumRows': 'рядків: {n}',
  'automation.sumAuto': 'за іменами шарів',
  'automation.sumRules': 'правил: {n}',
  'automation.sumWebhook': 'Вебхук',
  'automation.sumManual': 'Вручну або через API',
  'automation.step1': 'Шаблони',
  'automation.step1Hint':
    'Кожен рядок даних буде відмальовано в кожному вибраному шаблоні. Виберіть набір — додадуться всі його розміри.',
  'automation.noTemplates': 'Спочатку створіть шаблон.',
  'automation.step2': 'Дані',
  'automation.step2Hint': 'Один рядок — один комплект креативів',
  'automation.uploadCsv': 'Завантажити CSV',
  'automation.csvLoaded': 'Завантажено рядків: {n}',
  'automation.columnsFromLayers': 'Колонки з шарів',
  'automation.addColumn': 'Колонка',
  'automation.addRow': 'Рядок',
  'automation.rowsCount': 'Рядків: {n}',
  'automation.rowsHidden': 'Ще {n} рядків не показано, але їх буде згенеровано.',
  'automation.tableHint':
    'Колонка з іменем шару (title) підставить основне значення, колонка «шар.властивість» (title.color) — конкретну властивість. Порожня клітинка залишає значення з шаблону.',
  'automation.sheetUrl': 'Посилання на Google Таблицю',
  'automation.sheetHint':
    'Публічна таблиця («доступ за посиланням») працює без підключення акаунта. Перший рядок — заголовки.',
  'automation.googleAccount': 'Акаунт Google',
  'automation.publicSheet': 'Публічне посилання (без акаунта)',
  'automation.sheetName': 'Аркуш',
  'automation.firstSheet': 'перший аркуш',
  'automation.testSource': 'Перевірити й показати дані',
  'automation.sourceOk': 'Отримано рядків: {n}, колонок: {c}',
  'automation.urlHint': 'Дані завантажуються під час кожного запуску — зручно для фідів товарів',
  'automation.xmlHint':
    'Фіди Google Merchant і Meta (RSS/Atom), YML для Rozetka та Prom або будь-який XML. З кожного товару виходять колонки title, price, old_price, discount, currency, image, link, brand, category — назвіть так шари, і вони заповняться самі.',
  'automation.onlyChanged': 'Лише нові та змінені рядки',
  'automation.onlyChangedHint':
    'Запуск рендерить лише те, що з’явилося або змінилося з минулого разу (ціна, фото, назва). Змінили шаблон, зіставлення чи формат — перемалюється все. Зручно для щоденного фіду: не витрачає генерації на ті самі банери.',
  'automation.keyColumn': 'Колонка-ідентифікатор',
  'automation.keyColumnHint':
    'За нею рядок упізнається від запуску до запуску — зазвичай id або артикул',
  'automation.keyWholeRow': '— увесь рядок —',
  'automation.unchangedShort': 'без змін: {n}',
  'batch.unchanged': 'Пропущено рядків без змін: {n}',
  'batch.nothingChanged':
    'З минулого запуску нічого не змінилося ({n} рядків) — генерації не витрачено.',
  'err.xmlEntities': 'XML з оголошеннями сутностей (<!ENTITY>) не підтримується',
  'err.xmlParse': 'Не вдалося прочитати XML: {detail}',
  'err.feedEmpty': 'У XML-фіді не знайдено товарів',
  'automation.format': 'Формат',
  'automation.apiHint':
    'Рядки передаються в тілі запиту під час запуску — зручно для інтеграції з CRM, n8n, Make, Zapier.',
  'automation.step3': 'Зіставлення полів',
  'automation.step3Hint': 'Що підставити в кожен шар',
  'automation.autoMap': 'Автозіставлення за іменами',
  'automation.autoMapHint': 'Колонки, що збігаються з іменами шарів, підставляються самі',
  'automation.selectTemplatesFirst': 'Виберіть шаблони, щоб побачити їхні шари.',
  'automation.templatesLoadFailed': 'Не вдалося завантажити поля шаблонів.',
  'automation.noFieldsInTemplates': 'У вибраних шаблонах немає шарів для заповнення.',
  'automation.value': 'Значення',
  'automation.sample': 'Приклад (1-й рядок)',
  'automation.inTemplates': 'у {n} з {total}',
  'automation.auto': 'Авто: колонка {column}',
  'automation.keepTemplate': 'Як у шаблоні',
  'automation.column': 'Колонка',
  'automation.static': 'Фіксоване значення',
  'automation.extraRules': 'Додаткові правила',
  'automation.extraRulesHint':
    'Наприклад, колір плашки з колонки color або фіксований колір тексту.',
  'automation.addRule': 'Додати правило',
  'automation.previewFirstRow': 'Превʼю першого рядка',
  'automation.livePreview': 'Живий попередній перегляд',
  'automation.prevRow': 'Попередній рядок',
  'automation.nextRow': 'Наступний рядок',
  'automation.rowN': 'рядок {n} з {total}',
  'automation.livePreviewHint':
    'Наведіть на шар у таблиці — він підсвітиться тут. Клік по елементу макета покаже його рядок.',
  'automation.livePreviewMedia':
    'Зображення з медіатеки ({layers}) підставляться під час генерації',
  'automation.livePreviewFailed': 'Значення не підходить, шар залишиться як у шаблоні: {layers}',
  'automation.lockedLayer': 'Заблокований у редакторі — автоматизація його не змінює',
  'automation.step4': 'Формат файлів',
  'automation.formats': 'Формати',
  'automation.scale': 'Масштаб',
  'automation.scaleCapped':
    'Великі шаблони вийдуть меншими: {list}. Зображення — не більше {side} px по стороні та {mpx} Мп.',
  'automation.scaleNotUsed': 'PDF векторний, відео — у розмірі шаблону: масштаб на них не впливає.',
  'automation.quality': 'Якість JPG/WEBP',
  'automation.filename': "Ім'я файлу",
  'automation.filenameHint':
    'Плейсхолдери: {{template}}, {{index}}, {{date}}, {{format}}, {{row.колонка}}',
  'automation.folders': 'Теки для файлів',
  'automation.foldersHint':
    'Для ZIP, Google Drive і S3. Виберіть по порядку, як розкладати файли: перша — зовнішня тека. Без вибору всі файли лежать разом.',
  'automation.folderExampleTemplate': 'Шаблон',
  'automation.folderBy.template': 'За шаблоном',
  'automation.folderBy.size': 'За розміром',
  'automation.folderBy.format': 'За форматом',
  'automation.folderBy.column': 'За колонкою',
  'automation.step5': 'Куди надіслати',
  'automation.step5Hint': 'Можна вибрати кілька',
  'automation.destZip': 'ZIP-архів для завантаження',
  'automation.connectGoogle': 'Підключити Google',
  'automation.connectS3': 'Підключити S3',
  'automation.folderName': 'Папка',
  'automation.subfolderPerRun': 'Підпапка на кожен запуск',
  'automation.step6': 'Розклад',
  'automation.step6Hint': 'Наприклад, щоранку забирати фід і оновлювати креативи',
  'automation.scheduleOn': 'Запускати за розкладом',
  'automation.frequency': 'Періодичність',
  'automation.timezone': 'Часовий пояс',
  'automation.nextRuns': 'Найближчі запуски',
  'automation.invalidCron': 'Некоректний cron-вираз',
  'automation.cron.hourly': 'Щогодини',
  'automation.cron.daily': 'Щодня о 9:00',
  'automation.cron.weekly': 'Щопонеділка о 9:00',
  'automation.cron.monthly': '1-го числа о 9:00',
  'automation.cron.custom': 'Свій вираз',
  'automation.runs': 'Історія запусків',
  'automation.estimate': 'Буде створено файлів: {n}',
  'automation.estimateUnknown': 'Кількість стане відома після завантаження даних',
  'automation.overLimit': 'більше за ліміт тарифу ({n} за запуск)',
  'automation.saveAndRun': 'Зберегти й запустити',
  'automation.saved': 'Автоматизацію збережено',
  'automation.deleteTitle': 'Видалити автоматизацію?',
  'automation.deleteText': 'Історія запусків і згенеровані файли залишаться.',
  'destination.zip': 'ZIP-архів',
  'destination.google_drive': 'Google Drive',
  'destination.s3': 'Amazon S3 / сумісне сховище',
  'destination.webhook': 'Вебхук',
  'batch.title': 'Запуск',
  'batch.status.pending': 'Підготовка',
  'batch.status.processing': 'Генерація',
  'batch.status.done': 'Готово',
  'batch.status.partial': 'Частково',
  'batch.status.failed': 'Помилка',
  'batch.trigger.manual': 'вручну',
  'batch.trigger.schedule': 'за розкладом',
  'batch.trigger.api': 'через API',
  'batch.total': 'усього',
  'batch.done': 'готово',
  'batch.failed': 'помилок',
  'batch.finished': 'Завершено',
  'batch.downloadZip': 'Завантажити ZIP',
  'batch.deliveries': 'Доставка',
  'batch.files': 'файлів: {n}',
  'batch.showingFirst': 'Показано перші 200 файлів — усі файли є в ZIP-архіві.',
  'renders.description': 'Усі згенеровані зображення та PDF',
  'renders.tabRenders': 'Файли',
  'renders.tabBatches': 'Пакети',
  'renders.allStatuses': 'Усі статуси',
  'renders.allSources': 'Усі джерела',
  'renders.file': 'Файл',
  'renders.status': 'Статус',
  'renders.source': 'Джерело',
  'renders.size': 'Розмір',
  'renders.created': 'Створено',
  'renders.duration': 'Час',
  'renders.modifications': 'Передані дані',
  'renders.emptyTitle': 'Генерацій поки немає',
  'renders.emptyText':
    "Запустіть автоматизацію або надішліть запит до API — результати з'являться тут.",
  'renders.noBatches': 'Пакетних запусків поки немає',
  'renders.loadMore': 'Показати ще',
  'renders.sources.api': 'API',
  'renders.sources.editor': 'Редактор',
  'renders.sources.automation': 'Автоматизація',
  'renders.sources.url': 'Підписане посилання',
  'renders.statuses.queued': 'У черзі',
  'renders.statuses.rendering': 'Рендериться',
  'renders.statuses.done': 'Готово',
  'renders.statuses.failed': 'Помилка',
  'assets.description': 'Фото, логотипи та іконки для шаблонів',
  'assets.storage': 'Сховище: {used} з {limit}',
  'assets.drop':
    'Перетягніть фото або відео чи натисніть для вибору (PNG, JPG, WEBP, SVG, GIF, MP4, MOV, WEBM)',
  'assets.importUrl': 'Імпорт за URL',
  'assets.emptyTitle': 'Медіатека порожня',
  'assets.emptyText': 'Завантажте логотипи та фото, щоб використовувати їх у шаблонах.',
  'assets.copyUrl': 'Копіювати URL',
  'assets.deleteTitle': 'Видалити файл?',
  'assets.deleteText': 'Шаблони, де він використовується, покажуть порожнє місце.',
  'fonts.description':
    'Вмикайте потрібні шрифти й завантажуйте фірмові — вони будуть доступні в редакторі та під час генерації',
  'fonts.custom': 'Свої шрифти',
  'fonts.builtin': 'Вбудовані',
  'fonts.customBadge': 'свій',
  'fonts.customLocked': 'Свої шрифти — на тарифах Pro і Business',
  'fonts.filterAll': 'Усі',
  'fonts.filterEnabled': 'Увімкнені',
  'fonts.filterCyrillic': 'З кирилицею',
  'fonts.sampleText':
    'Жебракують філософи при ґанку церкви в Гадячі, ще й шатро їхнє п’яне знаємо.',
  'fonts.cyrillic': 'Кирилиця',
  'fonts.cyrShort': 'Кир',
  'fonts.sample': 'Текст для попереднього перегляду',
  'fonts.enabledCount': 'Увімкнено {n} з {total}',
  'fonts.disableHint':
    'Вимкнені шрифти ховаються з редактора, але вже створені шаблони й далі рендеритимуться коректно.',
  'fonts.files': 'Завантажені файли',
  'fonts.uploadTitle': 'Завантажити шрифт',
  'fonts.uploadHint':
    'TTF, OTF, WOFF або WOFF2. Кожне накреслення — окремий файл з тим самим сімейством.',
  'fonts.dropFont': 'Перетягніть файл шрифту або натисніть',
  'fonts.family': 'Сімейство',
  'fonts.familyHint': 'Залиште порожнім — візьмемо з файлу',
  'fonts.weight': 'Насиченість',
  'fonts.style': 'Накреслення',
  'fonts.auto': 'Визначити автоматично',
  'fonts.upload': 'Завантажити',
  'fonts.uploaded': 'Шрифт {family} {weight} завантажено',
  'fonts.deleteTitle': 'Видалити файл шрифту?',
  'fonts.deleteText': 'Шаблони з цим накресленням використовуватимуть запасний шрифт.',
  'api.description': 'Підключіть генерацію до свого сайту, CRM або скриптів',
  'api.keys': 'API-ключі',
  'api.keysHint': 'Ключ дає доступ до всіх шаблонів простору. Зберігайте його на сервері.',
  'api.createKey': 'Створити ключ',
  'api.adminOnly': 'Керувати ключами можуть адміністратори.',
  'api.noKeys': 'Ключів поки немає',
  'api.created': 'створено',
  'api.lastUsed': 'використано',
  'api.neverUsed': 'не використовувався',
  'api.revoke': 'Відкликати',
  'api.revokeTitle': 'Відкликати ключ?',
  'api.revokeText': 'Запити з ключем «{name}» одразу перестануть працювати.',
  'api.keyCreated': 'Ключ створено',
  'api.copyNow': 'Скопіюйте ключ зараз — більше ми його не покажемо.',
  'api.keyNameHint': 'Наприклад, де він використовується',
  'api.quickstart': 'Швидкий старт',
  'api.reference': 'Документація',
  'api.tabSingle': 'Одна картинка',
  'api.tabBatch': 'Пакет',
  'api.tabAsync': 'Асинхронно',
  'api.layersHelp':
    "зміни за іменами шарів: рядок — основне значення, об'єкт — властивості, null — сховати шар.",
  'api.scaleHelp': '2 для ретини.',
  'api.webhookHelp': 'повідомимо, коли файл готовий (підпис HMAC).',
  'api.signedTitle': 'Підписані посилання на картинки',
  'api.signedHint':
    'Картинка генерується під час першого відкриття посилання і кешується. Підходить для email-розсилок, Open Graph і лендингів — без серверного коду.',
  'api.generateUrl': 'Згенерувати посилання',
  'api.urlAppearsHere': "Посилання та превʼю з'являться тут",
  'api.signingSecret': 'Секрет підпису',
  'api.signingSecretHint':
    'Ним підписуються посилання та вебхуки. Підписуйте посилання на своєму боці — приклад нижче.',
  'api.reveal': 'Показати',
  'api.rotate': 'Змінити секрет',
  'api.rotateTitle': 'Змінити секрет?',
  'api.rotateText':
    'Усі раніше видані підписані посилання перестануть працювати, вебхуки почнуть підписуватися новим секретом.',
  'integrations.description': 'Звідки брати дані й куди складати готові файли',
  'integrations.locked': 'Інтеграції доступні на тарифах Starter і вище.',
  'integrations.googleHint': 'Читання Google Таблиць і вивантаження файлів у Google Drive',
  'integrations.googleNotConfigured':
    'Google OAuth не налаштовано на сервері (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET). Публічні таблиці працюють і без нього.',
  'integrations.connectGoogle': 'Підключити акаунт Google',
  'integrations.googleConnected': 'Google підключено',
  'integrations.googleReconnected': 'Цей акаунт Google уже підключено — доступ оновлено',
  'integrations.googleFailed': 'Не вдалося підключити Google',
  'integrations.s3Short': 'AWS, Cloudflare R2, MinIO, Wasabi, DigitalOcean…',
  'integrations.addBucket': 'Додати бакет',
  'integrations.s3Title': 'Підключення S3',
  'integrations.s3Hint': 'Перевіримо доступ, записавши службовий файл .bannermatic-check',
  'integrations.endpointHint': 'Для не-AWS сховищ',
  'integrations.publicBase': "Публічна адреса (необов'язково)",
  'integrations.testAndSave': 'Перевірити й зберегти',
  'integrations.connected': 'Підключено',
  'integrations.webhooks': 'Вебхуки',
  'integrations.webhooksHint': 'POST-сповіщення про готові рендери й пакети, підписані HMAC-SHA256',
  'integrations.defaultWebhook': 'Вебхук за замовчуванням для автоматизацій',
  'integrations.defaultWebhookHint': 'Отримує batch.completed після кожного запуску',
  'integrations.testWebhook': 'Тестовий вебхук',
  'integrations.send': 'Надіслати',
  'integrations.testSent': 'Тестову подію поставлено в чергу',
  'integrations.verifyTitle': 'Перевірка підпису',
  'integrations.recentDeliveries': 'Останні доставки',
  'integrations.removeTitle': 'Відключити інтеграцію?',
  'integrations.removeText': 'Автоматизації, які її використовують, не зможуть доставити файли.',
  'settings.tabGeneral': 'Основне',
  'settings.tabMembers': 'Команда',
  'settings.tabBilling': 'Тариф',
  'settings.tabProfile': 'Профіль',
  'settings.workspace': 'Робочий простір',
  'settings.dangerZone': 'Небезпечна зона',
  'settings.deleteWorkspace': 'Видалити простір',
  'settings.deleteWorkspaceText':
    'Буде видалено всі шаблони, файли, ключі та історію генерацій. Дія незворотна.',
  'settings.deleteWorkspaceConfirm': 'Точно видалити «{name}» з усіма даними?',
  'settings.lastWorkspace': 'Це ваш єдиний простір, тому видалити його не можна.',
  'workspace.noneTitle': 'У вас немає робочого простору',
  'workspace.noneText':
    'Створіть простір, щоб працювати з шаблонами, або попросіть колег запросити вас до свого.',
  'settings.invite': 'Запросити до команди',
  'settings.inviteHint': 'Надішлемо лист із посиланням-запрошенням.',
  'settings.seats': 'Місць: {used} з {limit}.',
  'settings.sendInvite': 'Запросити',
  'settings.invited': 'Запрошення надіслано',
  'settings.inviteLink': 'Посилання',
  'settings.you': 'ви',
  'settings.remove': 'Видалити з команди',
  'settings.pendingInvites': 'Очікують прийняття',
  'settings.expires': 'до',
  'settings.rolesTitle': 'Ролі',
  'settings.roleOwner': 'усе, включно з оплатою та видаленням простору',
  'settings.roleAdmin': 'команда, API-ключі, інтеграції',
  'settings.roleEditor': 'шаблони, медіа, шрифти, автоматизації та генерація',
  'settings.roleViewer': 'перегляд шаблонів і результатів',
  'settings.language': 'Мова інтерфейсу',
  'settings.changePassword': 'Змінити пароль',
  'settings.currentPassword': 'Поточний пароль',
  'settings.passwordChanged': 'Пароль змінено',
  'billing.currentPlan': 'Поточний тариф',
  'billing.renewsOn': 'Продовження',
  'billing.endsOn': 'Діє до',
  'billing.manage': 'Керування підпискою',
  'billing.rendersPeriod': 'Генерації в поточному періоді',
  'billing.storage': 'Сховище',
  'billing.plans': 'Тарифи',
  'billing.monthly': 'Щомісяця',
  'billing.yearly': 'Річний (−{n}%)',
  'billing.mo': 'міс',
  'billing.popular': 'Популярний',
  'billing.current': 'Поточний тариф',
  'billing.choose': 'Вибрати',
  'billing.thanks': 'Дякуємо! Підписка активується протягом хвилини.',
  'billing.switched': 'Тариф змінено',
  'billing.devMode':
    'Оплату не підключено: увімкнено режим розробки — тариф перемикається без оплати. Для продакшену підключіть Lemon Squeezy (LEMONSQUEEZY_API_KEY) або Stripe (STRIPE_SECRET_KEY).',
  'billing.noStripe': 'Оплату не налаштовано на сервері. Зверніться до адміністратора.',
  'billing.fRenders': 'Генерацій на місяць: {n}',
  'billing.fTemplates': 'Шаблонів: до {n}',
  'billing.fTemplatesUnlimited': 'Безліміт шаблонів',
  'billing.fMembers': 'Учасників: до {n}',
  'billing.fMembersUnlimited': 'Безліміт учасників',
  'billing.fAutomations': 'Автоматизацій: до {n}',
  'billing.fAutomationsUnlimited': 'Безліміт автоматизацій',
  'billing.fBatch': 'Файлів за запуск: до {n}',
  'billing.fFonts': 'Свої шрифти',
  'billing.fIntegrations': 'Google Drive, Sheets, S3',
  'billing.fSigned': 'Підписані посилання на картинки',
  'billing.fSchedule': 'Автоматизації за розкладом',
  'billing.fNoWatermark': 'Без водяного знака',
  'landing.navFeatures': 'Можливості',
  'landing.navSpreadsheets': 'Таблиці',
  'landing.navPricing': 'Ціни',
  'landing.navDocs': 'Документація API',
  'landing.login': 'Увійти',
  'landing.startFree': 'Почати безкоштовно',
  'landing.openApp': 'Відкрити застосунок',
  'landing.badge': 'Шаблони · Таблиці · API',
  'landing.title': 'Сотні банерів з одного шаблону — за хвилини',
  'landing.subtitle':
    'Зберіть шаблон у візуальному редакторі, а далі підставляйте тексти, фото, ціни й логотипи через API, Google Таблиці або CSV. На виході — PNG, JPG, WEBP і PDF.',
  'landing.ctaPrimary': 'Створити перший шаблон',
  'landing.ctaSecondary': 'Подивитися API',
  'landing.noCard': "Безкоштовний тариф назавжди. Без прив'язки картки.",
  'landing.demoRows': 'рядків: {n}',
  'landing.uc1': 'Картки товарів для маркетплейсів',
  'landing.uc2': 'Медійна реклама в усіх розмірах',
  'landing.uc3': 'Пости й сторіс для соцмереж',
  'landing.uc4': 'OG-картинки та email-банери',
  'landing.demo1Title': 'Літній розпродаж',
  'landing.demo1Subtitle': 'Знижки на всю колекцію',
  'landing.demo2Title': 'Нова колекція кросівок для бігу',
  'landing.demo2Subtitle': 'Легкі, швидкі, дихаючі',
  'landing.demo3Title': 'Black Friday',
  'landing.demo3Subtitle': 'Лише 3 дні — встигніть',
  'landing.demo4Title': 'Подарункові сертифікати',
  'landing.demo4Subtitle': 'Ідеальний подарунок до свят',
  'landing.demoFrom': 'від {price}',
  'landing.uc5': 'Сертифікати та прайси в PDF',
  'landing.featuresTitle': 'Усе для потокової генерації креативів',
  'landing.featuresSubtitle':
    'Дизайнер робить шаблон один раз, а далі креативи збираються самі — з API, таблиць і фідів.',
  'landing.f1Title': 'Візуальний редактор',
  'landing.f1Text':
    'Шари, текст, фото, логотипи, фігури, QR-коди, градієнти, тіні, розумні напрямні, автопідгонка довгого тексту.',
  'landing.f2Title': 'REST API',
  'landing.f2Text':
    'Синхронні й асинхронні рендери, пакети до тисяч файлів, вебхуки з підписом, OpenAPI-документація.',
  'landing.f3Title': 'Студія автоматизації',
  'landing.f3Text':
    'CSV, Google Таблиці, товарні фіди Google Merchant, Meta та YML (Rozetka, Prom) × кілька шаблонів → ZIP, Google Drive, S3 або вебхук. За розкладом — лише змінені товари.',
  'landing.f4Title': 'Ваші шрифти',
  'landing.f4Text':
    '40 популярних шрифтів з кирилицею вже всередині. Завантажте фірмові TTF/OTF/WOFF і вимкніть зайві.',
  'landing.f5Title': 'Картинки й відео',
  'landing.f5Text':
    'PNG з прозорістю, JPG, WEBP, векторний PDF для друку, ретина до 3x — і відео MP4, WebM, GIF для Reels, TikTok і Shorts.',
  'landing.f6Title': 'Точно як у редакторі',
  'landing.f6Text':
    'Редактор і сервер рендерять одним і тим самим рушієм — що бачите, те й отримаєте.',
  'landing.howTitle': 'Як це працює',
  'landing.step1Title': 'Зберіть шаблон',
  'landing.step1Text': 'Розставте шари в редакторі й назвіть динамічні: title, photo, price.',
  'landing.step2Title': 'Підключіть дані',
  'landing.step2Text':
    'Надішліть JSON в API, завантажте CSV або дайте посилання на Google Таблицю.',
  'landing.step3Title': 'Отримайте файли',
  'landing.step3Text':
    'Готові креативи приходять посиланнями, ZIP-архівом, у Drive, S3 або на ваш вебхук.',
  'landing.apiTitle': 'API, яке зручно вбудувати',
  'landing.apiText':
    'Один запит — одна картинка. Або тисяча в пакеті. Працює з будь-якої мови, n8n, Make і Zapier.',
  'landing.api1': 'Змінюйте текст, фото, кольори, позиції та видимість шарів за їхніми іменами',
  'landing.api2': 'Чекайте результат у відповіді або отримуйте вебхук',
  'landing.api3': 'Підписані посилання — картинка за URL без серверного коду',
  'landing.api4': 'Ліміти, ключі, логи доставки — усе прозоро',
  'landing.apiCalloutTitle': 'Движок автоматичної генерації',
  'landing.apiCalloutText':
    'Передавайте параметри шарів через API, вебхуки або таблиці — швидкий паралельний рендеринг.',
  'landing.pricingTitle': 'Прості тарифи',
  'landing.pricingSubtitle': 'Платіть за кількість генерацій. Редактор і API — на всіх тарифах.',
  'landing.tryPlan': 'Вибрати {plan}',
  'landing.watermark': 'З водяним знаком',
  'landing.faqTitle': 'Питання та відповіді',
  'landing.q1': 'Чим це відрізняється від звичайного графічного редактора?',
  'landing.a1':
    'Звичайний редактор — для ручного дизайну. Bannermatic — для потоку: один шаблон перетворюється на сотні варіантів автоматично, через API, таблиці й розклад.',
  'landing.q2': 'Чи можна змінювати положення елементів, а не лише текст?',
  'landing.a2':
    'Так. У запиті для будь-якого шару можна передати x, y, width, height, rotation і opacity, змінити колір (color) або сховати шар (hide: true чи null), наприклад: {"logo": {"x": 40, "y": 860, "width": 180}}. Шари всередині стеку розставляє автолейаут — для них змінюються розмір, напрямок і відступ стеку (direction, gap), а не координати.',
  'landing.q3': 'Що буде з довгим текстом?',
  'landing.a3':
    'Увімкніть автопідгонку: шрифт зменшиться, щоб текст помістився, або обмежте кількість рядків із трикрапкою.',
  'landing.metaTitle':
    'Bannermatic — Автоматична генерація банерів за шаблонами через API та Google Таблиці',
  'landing.metaDescription':
    'Візуальний редактор шаблонів та REST API для масової генерації банерів, карток товарів для маркетплейсів, креативів для соцмереж і PDF з Google Таблиць, фідів та CSV.',
  'landing.q4': 'Чи підтримуються кирилиця та свої шрифти?',
  'landing.a4':
    'Так, більшість вбудованих шрифтів мають кирилицю, а на платних тарифах можна завантажити свої TTF/OTF/WOFF.',
  'landing.q5': 'Як генерувати банери з Google Таблиць без знання коду?',
  'landing.a5':
    'Підключіть Google Таблицю або завантажте CSV у Студії автоматизації. Стовпці таблиці зіставляються з шарами шаблону (title, price, photo), і Bannermatic збирає сотні готових банерів у ZIP-архів, Google Drive або S3.',
  'landing.q6': 'Чи підходить сервіс для карток товарів на маркетплейсах?',
  'landing.a6':
    'Так, це один із головних сценаріїв. Ви можете масово накладати знижкові плашки, характеристики, ціни та логотипи брендів на фотографії товарів із вашого фіду або каталогу.',
  'landing.finalTitle': 'Досить збирати банери вручну',
  'landing.finalText': 'Зробіть шаблон за 10 хвилин і віддайте рутину API.',
  'landing.tablesBadge': 'Без коду · Студія таблиць',
  'landing.tablesTitle': 'Банери з таблиць без коду',
  'landing.tablesSubtitle':
    'Підключіть Google Таблицю або завантажте CSV. Колонки автоматично зв’язуються з шарами шаблону, створюючи сотні готових банерів в один клік.',
  'landing.tablesPoint1Title': 'Імпорт із Google Sheets та CSV',
  'landing.tablesPoint1Text':
    'Підключіть онлайн-таблицю або перетягніть файл із товарами. Bannermatic миттєво зчитає структуру даних.',
  'landing.tablesPoint2Title': 'Наочний мапінг колонок',
  'landing.tablesPoint2Text':
    'Вкажіть, яка колонка відповідає за назву, ціну, знижку чи фото товару. Розумний помічник зв’яже шари автоматично.',
  'landing.tablesPoint3Title': 'Пакетна генерація та експорт',
  'landing.tablesPoint3Text':
    'Сотні банерів рендеряться паралельно за секунди. Завантажуйте ZIP-архів або зберігайте безпосередньо у хмару.',
  'landing.tablesMascotBubble': 'Додав таблицю — і погнали!',
  'landing.tablesCta': 'Спробувати Студію автоматизації',
  'landing.tablesMockSync': 'Синхронізовано · 450 рядків',
  'landing.tablesMockBtn': 'Згенерувати 450 банерів',
  'landing.tablesMockColProduct': 'Товар',
  'landing.tablesMockColPrice': 'Ціна',
  'landing.tablesMockColDiscount': 'Знижка',
  'landing.tablesMockColPhoto': 'Фото',
  'landing.tablesMockColStatus': 'Статус',
  'landing.tablesMockDone': 'Готово',
  'automation.autoMapped': 'Зіставлено колонок: {n}',
  'automation.autoMapNone': 'Нових збігів колонок зі шарами не знайдено',
  'automation.matchColumns': 'Зіставити колонки',
  'automation.mediaHint': 'У клітинках для картинок можна вказувати файли з медіатеки:',
  'media.allFiles': 'Усі файли',
  'media.noFolder': 'Без папки',
  'media.folders': 'Папки',
  'media.newFolder': 'Нова папка',
  'media.renameFolder': 'Перейменувати папку',
  'media.renameFile': 'Перейменувати файл',
  'media.rename': 'Перейменувати',
  'media.moveTo': 'Перемістити в папку',
  'media.moved': 'Файл переміщено',
  'media.folderPlaceholder': 'Наприклад, Команди',
  'media.foldersHint':
    'Розкладіть логотипи й фони по папках — «Команди», «Ліги»… Файли можна перетягувати на папку.',
  'media.dropInto': 'Перетягніть файли сюди, і вони потраплять у папку «{folder}»',
  'media.search': 'Пошук за назвою файлу чи папки',
  'media.nothingFound': 'Нічого не знайдено',
  'media.copyRef': 'Копіювати посилання для автоматизації',
  'media.refCopied': 'Скопійовано — вставте в клітинку таблиці або в API',
  'media.refHint': 'У таблицях автоматизації та API картинку можна вказати так:',
  'media.exampleFolder': 'Команди',
  'media.exampleName': 'Арсенал',
  'media.deleteFolderTitle': 'Видалити папку «{name}»?',
  'media.deleteFolderText':
    'Файли з неї не видаляться — вони переїдуть у «Без папки». Посилання media:Папка/… перестануть знаходити ці файли.',
  'media.allFolders': 'Усі папки',
  'media.pick': 'Вибрати з медіатеки',
  'err.folderExists': 'Папка «{name}» вже існує',
  'err.nameRequired': 'Введіть назву',
  'err.mediaNotFound': 'Шар «{layer}»: «{ref}» немає в медіатеці',
  'qr.style': 'Стиль QR-коду',
  'qr.paid':
    'Заокруглені точки, стиль кутів, власний колір і логотип у центрі — на тарифах Pro та Business.',
  'qr.upgrade': 'Змінити тариф',
  'qr.dots': 'Точки',
  'qr.eyes': 'Кути',
  'qr.eyeColor': 'Колір кутів',
  'qr.logo': 'Логотип у центрі',
  'qr.logoHint': 'Доступно на Pro та Business',
  'qr.logoSize': 'Розмір лого',
  'qr.logoNote':
    'З логотипом код використовує максимальну корекцію помилок (H) — перевірте сканування на превʼю.',
  'qr.dot.square': 'Квадрати',
  'qr.dot.rounded': 'Заокруглені',
  'qr.dot.dots': 'Кола',
  'qr.eye.square': 'Квадрат',
  'qr.eye.rounded': 'Заокруглений',
  'qr.eye.circle': 'Коло',
  'billing.fQrStyles': 'Стильні QR-коди з логотипом',
  'retention.label': 'Зберігається',
  'retention.until': 'до {date}',
  'retention.keptUntil': 'Файли зберігаються до {date}',
  'retention.batchExpired': 'Термін зберігання файлів минув — їх видалено',
  'retention.renderExpired': 'Файл видалено після завершення терміну зберігання',
  'google.spreadsheet': 'Таблиця',
  'google.chooseSpreadsheet': 'Виберіть таблицю',
  'google.noSpreadsheets': 'Поки немає таблиць — виберіть у Google Drive або вставте посилання',
  'google.listHint':
    'Google показує застосункам лише таблиці, вибрані через «Google Drive» або вже використані в автоматизаціях.',
  'google.refresh': 'Оновити список',
  'google.fromDrive': 'Google Drive',
  'google.orLink': '…або посилання на таблицю',
  'google.linkedSheet': 'Таблиця за посиланням',
  'google.noAccess':
    'Не вдалося відкрити таблицю цим акаунтом Google — перевірте посилання й доступ.',
  'google.noAccessPick':
    'Bannermatic бачить лише таблиці, вибрані в Google Drive. Відкрийте цю таблицю там один раз — доступ буде лише до неї.',
  'google.grantAccess': 'Надати доступ до цієї таблиці',
  'common.loading': 'Завантаження…',
  'common.retry': 'Спробувати ще',
  'err.pickerOwnerOnly':
    'Переглядати Google Drive може лише той, хто підключив акаунт, або адміністратор',
  'err.pickerDisabled': 'Вибір із Google Drive не налаштовано на сервері',
  'common.close': 'Закрити',
  'common.menu': 'Меню',
  'history.title': 'Історія версій',
  'history.paid':
    'Історія змін шаблону з відкатом до будь-якої збереженої версії — на тарифі Business.',
  'history.restore': 'Відновити цю версію',
  'history.restored': 'Відновлено версію від {time}',
  'history.empty': 'Версії з’являться після перших змін шаблону.',
  'history.current': 'Поточна',
  'history.restoreOf': 'Відкат до версії {version}',
  'history.initial': 'Початкова версія',
  'history.edited': 'Зміни',
  'history.hint':
    'Зміни однієї людини за ~10 хвилин — одна версія. Зберігається 180 днів, до 200 версій на шаблон.',
  'comments.title': 'Коментарі',
  'comments.paid': 'Коментарі до шаблонів для узгодження з командою — на тарифі Business.',
  'comments.empty': 'Поки немає коментарів. Виділіть шар, щоб прив’язати зауваження до нього.',
  'comments.resolve': 'Позначити вирішеним',
  'comments.reopen': 'Повернути в роботу',
  'comments.showResolved': 'Показати вирішені ({n})',
  'comments.hideResolved': 'Сховати вирішені',
  'comments.placeholder': 'Зауваження чи питання… (Ctrl+Enter — надіслати)',
  'comments.pin': 'До шару «{layer}»',
  'comments.send': 'Надіслати',
  'review.title': 'Погодження',
  'review.status.draft': 'Чернетка',
  'review.status.in_review': 'На погодженні',
  'review.status.changes_requested': 'На доопрацюванні',
  'review.status.approved': 'Затверджено',
  'review.hint.approved': 'Затверджено {time}. Зміни дизайну повернуть шаблон у чернетку.',
  'review.hint.inReview': 'Чекає рішення власника або адміністратора.',
  'review.hint.changes':
    'Потрібні правки — зауваження в коментарях нижче. Після правок надішліть знову.',
  'review.hint.edited': 'Змінено після затвердження.',
  'review.hint.editedRequired':
    'Змінено після затвердження. API, автоматизації та посилання малюють затверджену версію, доки не затвердять нову.',
  'review.hint.draft': 'Коли макет готовий, надішліть його на погодження.',
  'review.hint.draftRequired':
    'Ще не затверджено: API, автоматизації та посилання його не рендерять (прев’ю працюють).',
  'review.notePlaceholder': 'Що виправити? Зауваження потрапить у коментарі',
  'review.sendBack': 'Повернути на доопрацювання',
  'review.approve': 'Затвердити',
  'review.requestChanges': 'Потрібні правки',
  'review.request': 'Надіслати на погодження',
  'review.done.request': 'Шаблон надіслано на погодження',
  'review.done.approve': 'Шаблон затверджено',
  'review.done.changes': 'Шаблон повернуто на доопрацювання',
  'approval.title': 'Вимагати погодження шаблонів',
  'approval.text':
    'API, автоматизації та підписані посилання рендерять лише затверджену версію шаблону. Правки в редакторі не потраплять у розсилки й фіди, доки їх не затвердять. Прев’ю й генерація в редакторі працюють як раніше.',
  'approval.on': 'Погодження ввімкнено',
  'approval.off': 'Погодження вимкнено',
  'audit.template.review_requested': 'На погодження надіслано шаблон',
  'audit.template.approved': 'Затверджено шаблон',
  'audit.template.changes_requested': 'На доопрацювання повернуто шаблон',
  'err.templateNotApproved':
    'Шаблон «{name}» ще не затверджено. Затвердьте його в редакторі або вимкніть обов’язкове погодження.',
  'err.reviewAlreadyApproved': 'Цю версію вже затверджено',
  'activity.tab': 'Журнал',
  'activity.paid':
    'Журнал дій — хто що змінив і запустив — на тарифі Business. Події вже записуються: після переходу ви побачите й минулі.',
  'activity.description': 'Хто що змінив і запустив. Зберігається 365 днів.',
  'activity.allTypes': 'Усі події',
  'activity.empty': 'Подій поки немає',
  'activity.more': 'Показати ще',
  'activity.times': '×{n}',
  'activity.apiKey': 'API-ключ',
  'activity.system': 'Система',
  'activity.version': 'версія {n}',
  'activity.renders': 'файлів: {n}',
  'activity.trigger.manual': 'вручну',
  'activity.trigger.schedule': 'за розкладом',
  'activity.trigger.api': 'через API',
  'activity.type.template': 'Шаблони',
  'activity.type.automation': 'Автоматизації',
  'activity.type.member': 'Команда',
  'activity.type.api_key': 'API-ключі',
  'activity.type.integration': 'Інтеграції',
  'activity.type.asset': 'Медіатека',
  'activity.type.font': 'Шрифти',
  'audit.template.created': 'Створено шаблон',
  'audit.template.imported': 'Імпортовано шаблон',
  'audit.template.updated': 'Змінено шаблон',
  'audit.template.deleted': 'Видалено шаблон',
  'audit.template.duplicated': 'Створено копію шаблону',
  'audit.template.restored': 'Відкат версії шаблону',
  'audit.comment.added': 'Коментар до шаблону',
  'audit.automation.created': 'Створено автоматизацію',
  'audit.automation.updated': 'Змінено автоматизацію',
  'audit.automation.deleted': 'Видалено автоматизацію',
  'audit.automation.run': 'Запуск автоматизації',
  'audit.batch.created': 'Пакетна генерація через API',
  'audit.member.invited': 'Запрошення надіслано',
  'audit.member.joined': 'До команди приєднався(-лася)',
  'audit.member.removed': 'Видалено з команди',
  'audit.member.left': 'Залишив(-ла) команду',
  'audit.member.role_changed': 'Змінено роль',
  'audit.invitation.revoked': 'Відкликано запрошення',
  'audit.api_key.created': 'Створено API-ключ',
  'audit.api_key.revoked': 'Відкликано API-ключ',
  'audit.integration.connected': 'Підключено інтеграцію',
  'audit.integration.updated': 'Перепідключено інтеграцію',
  'audit.integration.deleted': 'Відключено інтеграцію',
  'audit.asset.uploaded': 'Завантажено файли в медіатеку, останній:',
  'audit.asset.deleted': 'Видалено файл',
  'audit.folder.created': 'Створено папку',
  'audit.folder.deleted': 'Видалено папку',
  'audit.font.uploaded': 'Завантажено шрифт',
  'audit.font.deleted': 'Видалено шрифт',
  'audit.motion_preset.created': 'Створено пресет анімації',
  'audit.motion_preset.updated': 'Змінено пресет анімації',
  'audit.motion_preset.deleted': 'Видалено пресет анімації',
  'audit.workspace.updated': 'Змінено налаштування простору',
  'audit.signing_secret.rotated': 'Оновлено секрет підпису',
  'audit.plan.changed': 'Змінено тариф',
  'err.businessFeature': 'Доступно на тарифі Business',
  'err.commentEmpty': 'Напишіть коментар',
  'billing.fHistory': 'Історія версій, коментарі, погодження шаблонів, журнал дій',
  'brand.title': 'Бренд-кіт',
  'brand.description':
    'Кольори, шрифти й логотипи бренду задаються один раз — шаблони посилаються на них.',
  'brand.create': 'Створити бренд',
  'brand.newName': 'Бренд {n}',
  'brand.paid':
    'Бренд-кіт — на тарифах Pro (один бренд) і Business (кілька брендів, перемикання бренду клієнта в автоматизаціях і API).',
  'brand.emptyTitle': 'Брендів поки немає',
  'brand.emptyText': 'Створіть бренд і задайте його кольори, шрифти й логотипи.',
  'brand.moreOnBusiness': 'Кілька брендів (для агенцій і клієнтів) — на тарифі Business.',
  'brand.default': 'Основний',
  'brand.makeDefault': 'Зробити основним',
  'brand.saved': 'Бренд збережено — шаблони оновляться',
  'brand.colorsTitle': 'Кольори',
  'brand.fontsTitle': 'Шрифти',
  'brand.logosTitle': 'Логотипи',
  'brand.deleteTitle': 'Видалити бренд «{name}»?',
  'brand.deleteText':
    'Шаблони, що на нього посилаються, візьмуть основний бренд або запасні значення.',
  'brand.howTitle': 'Як це працює',
  'brand.howText':
    'У редакторі виберіть колір, шрифт чи логотип із розділу бренду — шар запам’ятає посилання на слот («Основний», «Заголовки», «Логотип»), а не значення. Змініть бренд — оновляться всі шаблони. У всіх брендів однакові слоти, тож один набір шаблонів працює для будь-якого клієнта: виберіть бренд в автоматизації або передайте brand_id в API.',
  'brand.colors': 'Кольори бренду «{name}»',
  'brand.fonts': 'Шрифти бренду «{name}»',
  'brand.logos': 'Логотипи бренду «{name}»',
  'brand.detach': 'Відв’язати від бренду (залишити поточний колір)',
  'brand.useDefault': 'Основний бренд ({name})',
  'brand.templateHint':
    'Бренд, з яким шаблон показується й рендериться, якщо автоматизація чи API не вибрали інший.',
  'brand.editorHint':
    'Кольори, шрифти й логотипи бренду можна задати один раз і використовувати в усіх шаблонах.',
  'brand.automationLabel': 'Бренд',
  'brand.automationHint': 'Кольори, шрифти й логотипи бренду для всіх банерів цього запуску.',
  'brand.templateBrand': 'Бренд кожного шаблону',
  'brand.slot.primary': 'Основний',
  'brand.slot.secondary': 'Додатковий',
  'brand.slot.accent': 'Акцент',
  'brand.slot.background': 'Фон',
  'brand.slot.text': 'Текст',
  'brand.slot.font-heading': 'Заголовки',
  'brand.slot.font-body': 'Основний текст',
  'brand.slot.logo': 'Логотип',
  'brand.slot.logo-light': 'Світлий логотип',
  'brand.slot.logo-icon': 'Іконка',
  'err.brandsPlan': 'Бренд-кіт доступний на тарифах Pro і Business',
  'err.brandsLimit': 'На вашому тарифі брендів: не більше {limit}',
  'err.brandInvalid': 'Перевірте значення бренду',
  'billing.fBrands': 'Бренд-кіт',
  'landing.brandDemoTitle': 'Нова колекція',
  'landing.brandDemoSub': 'Лише до неділі',
  'landing.brandsTitle': 'Один набір шаблонів — бренди всіх клієнтів',
  'landing.brandsSubtitle':
    'Задайте кольори, шрифти й логотипи бренду один раз. Шаблони посилаються на бренд-кіт: змінили фірмовий колір — оновилися всі банери. Перемикайте бренд клієнта в автоматизації або одним параметром API.',
  'landing.brandsP1Title': 'Бренд-кіт',
  'landing.brandsP1Text':
    'Кольори, шрифти, логотипи. На Pro — один бренд, на Business — скільки завгодно й перемикання на льоту.',
  'landing.brandsP2Title': 'Історія версій із відкатом',
  'landing.brandsP2Text':
    'Кожна сесія змін зберігається. Зламали шаблон перед запуском — повернули попередню версію в один клік.',
  'landing.brandsP3Title': 'Коментарі та погодження',
  'landing.brandsP3Text':
    'Зауваження просто до шару шаблону, статуси «на погодженні» й «затверджено». API та розсилки малюють лише затверджену версію — правки не підуть у продакшен без схвалення.',
  'landing.brandsP4Title': 'Журнал дій',
  'landing.brandsP4Text':
    'Хто змінив шаблон, хто запустив розсилку і через який API-ключ — видно все.',
  'landing.brandsDemoLabel': 'Один шаблон · три бренди',
  'landing.brandsDemoHint':
    'Це живий рендер: той самий шаблон, різні бренд-кіти — кольори, шрифти, акценти.',
  'landing.f7Title': 'Медіатека з папками',
  'landing.f7Text':
    'Логотипи команд, фото товарів, фони — по папках і з пошуком. У таблиці просто пишіть media:Команди/Арсенал — підставиться потрібний файл.',
  'landing.f8Title': 'QR-коди у фірмовому стилі',
  'landing.f8Text':
    'Заокруглені точки чи кола, стиль і колір кутів, логотип у центрі — і код однаково зчитується.',
  'landing.f9Title': 'Таблиця підхоплюється сама',
  'landing.f9Text':
    'Завантажили CSV чи вибрали Google Таблицю зі списку — колонки самі зіставляться зі шарами: «Заголовок», «Home Logo», «Ціна».',
  'landing.q7': 'Чи можна вести кількох клієнтів з різними брендами?',
  'landing.a7':
    'Так. На тарифі Business створіть бренд-кіт для кожного клієнта — кольори, шрифти, логотипи. Шаблони посилаються на бренд, тож той самий набір працює для всіх: виберіть бренд в автоматизації або передайте brand_id в API.',
  'landing.q8': 'Що, як хтось зламає шаблон?',
  'landing.a8':
    'На тарифі Business кожна сесія змін потрапляє в історію версій: відкрийте її, перегляньте превʼю й відновіть потрібну версію в один клік. Журнал дій покаже, хто й коли змінював шаблон.',
  'editor.tabBrand': 'Бренд',
  'brandPanel.empty':
    'Бренд-кіт ще не створено. Додайте кольори, шрифти й логотипи — і застосовуйте їх в один клік.',
  'brandPanel.toSelection': 'до виділених шарів ({n})',
  'brandPanel.toBackground': 'до тла полотна',
  'brandPanel.linked': 'Привʼязано до бренду: {n}',
  'brandPanel.nothingToLink': 'У шаблоні немає кольорів і шрифтів, що збігаються з брендом',
  'brandPanel.edit': 'Редагувати бренд-кіт',
  'brandPanel.clickHint':
    'Клік по кольору застосовує його {target}. Значення повʼязане з брендом і оновиться разом із ним.',
  'brandPanel.fontHint':
    'Клік — застосувати до виділеного тексту або додати новий текст цим шрифтом',
  'brandPanel.logoHint': 'Клік — замінити виділене зображення або додати логотип',
  'brandPanel.linkAll': 'Привʼязати шаблон до бренду',
  'brandPanel.linkAllHint':
    'Знайде в шаблоні кольори, шрифти й логотипи бренду та повʼяже їх — тоді інший бренд перефарбує банер повністю.',
  'brandImport.open': 'Імпорт',
  'brandImport.title': 'Імпорт бренд-кіту',
  'brandImport.description': 'Зберемо кольори, шрифти й логотипи із сайту або з файлу Figma.',
  'brandImport.reviewHint': 'Перевірте, що ми знайшли, і виправте за потреби.',
  'brandImport.back': 'Назад',
  'brandImport.replace': 'Оновити бренд',
  'brandImport.create': 'Створити бренд',
  'brandImport.website': 'Сайт',
  'brandImport.siteLabel': 'Адреса сайту',
  'brandImport.siteHint': 'Візьмемо кольори з CSS, шрифти й логотип з головної сторінки.',
  'brandImport.find': 'Знайти',
  'brandImport.figmaConnect': 'Підключіть Figma, щоб читати стилі та змінні файлу.',
  'brandImport.figmaStep1':
    'У Figma: Settings → Security → Personal access tokens → Generate new token (доступ на читання файлів).',
  'brandImport.figmaStep2': 'Вставте токен нижче — він зберігається в зашифрованому вигляді.',
  'brandImport.connect': 'Підключити',
  'brandImport.figmaLabel': 'Посилання на файл Figma',
  'brandImport.figmaHint':
    'Найкраще файл із дизайн-системою: стилі кольорів і тексту, логотипи як компоненти.',
  'brandImport.reading': 'Читаємо джерело…',
  'brandImport.name': 'Назва бренду',
  'brandImport.saveTo': 'Зберегти як',
  'brandImport.newBrand': 'Новий бренд',
  'brandImport.replaceBrand': 'Замінити «{name}»',
  'brandImport.pickFor': 'Виберіть колір',
  'brandImport.paletteHint': 'Знайдена палітра — клік призначить колір вибраному слоту',
  'brandImport.fontMissing':
    'Шрифту «{family}» немає в бібліотеці — виберіть схожий або завантажте файл шрифту.',
  'brandImport.noLogos': 'Логотипи не знайдено — їх можна додати пізніше.',
  'brandImport.skipLogo': 'Не імпортувати',
  'brandImport.saved': 'Бренд-кіт імпортовано',
  'integrations.figmaHint': 'Імпорт бренд-кіту зі стилів і змінних файлів Figma.',
  'err.siteHttp': 'Сайт відповів помилкою HTTP {status}.',
  'err.figmaLink': 'Це не схоже на посилання на файл Figma.',
  'err.figmaToken': 'Вставте токен Figma.',
  'err.figmaNotFound': 'Файл Figma не знайдено — перевірте посилання.',
  'err.figmaForbidden': 'Немає доступу: токен недійсний або акаунт не має доступу до файлу.',
  'err.figmaError': 'Figma повернула помилку. Спробуйте пізніше.',
  'brandDs.onPage': 'На сторінці',
  'brandDs.overview': 'Огляд',
  'brandDs.typography': 'Типографіка',
  'brandDs.usage': 'У дії',
  'brandDs.tagline': 'Кольори, шрифти й логотипи бренду — у кожному банері',
  'brandDs.colorsHint':
    'Клік по зразку — вибрати колір, або введіть HEX. Шаблони посилаються на слот (токен), а не на значення, тож зміна кольору перефарбує всі банери.',
  'brandDs.notSet': 'Не задано',
  'brandDs.contrast': 'Контраст пар',
  'brandDs.contrastHint':
    'Читабельність тексту за WCAG: AA — від 4.5, AAA — від 7, від 3 — лише для великого тексту.',
  'brandDs.pairSample': 'Розпродаж −30%',
  'brandDs.largeOnly': 'великий',
  'brandDs.fail': 'погано',
  'brandDs.typeHint':
    'Шрифт заголовків і основного тексту. Шари зі шрифтом бренду зміняться разом із бренд-кітом.',
  'brandDs.sampleHeadline': 'Яскравий банер за кілька секунд',
  'brandDs.sampleBody':
    'Шаблони беруть кольори, шрифти й логотипи з бренд-кіту, тож кожна генерація виглядає фірмово.',
  'brandDs.logosHint':
    'Основний логотип — для світлого тла, світлий — для темного (показано на основному кольорі), іконка — для малих форматів.',
  'brandDs.usageHint':
    'Так шаблони, привʼязані до бренду, виглядають із цим кітом. Превʼю одразу враховує незбережені зміни.',
  'brandDs.sampleCta': 'Купити',
  'brandDs.unsaved': 'Є незбережені зміни',
  'brandDs.discard': 'Скасувати',
  'keys.title': 'Гарячі клавіші',
  'keys.description':
    'Працюють, коли фокус на полотні. Літерні клавіші працюють у будь-якій розкладці.',
  'keys.general': 'Основне',
  'keys.layers': 'Шари',
  'keys.animation': 'Анімація',
  'keys.playPause': 'Відтворити / пауза',
  'keys.frameStep': 'На кадр назад / вперед',
  'keys.secondStep': 'На секунду назад / вперед',
  'keys.toStartEnd': 'На початок / в кінець',
  'keys.view': 'Вигляд',
  'keys.tools': 'Інструменти',
  'keys.save': 'Зберегти',
  'keys.cut': 'Вирізати',
  'keys.selectAll': 'Виділити все',
  'keys.delete': 'Видалити',
  'keys.deselect': 'Зняти виділення / вийти зі стеку',
  'keys.editText': 'Редагувати текст',
  'keys.dblclick': 'подвійний клік',
  'keys.cheatsheet': 'Ця шпаргалка',
  'editor.panelLeft': 'панель шарів',
  'editor.panelRight': 'панель властивостей',
  'editor.panelBottom': 'таймлайн і розкадровку',
  'editor.panelShow': 'Показати {panel}',
  'editor.panelHide': 'Згорнути {panel}',
  'editor.focus': 'Фокус на прев’ю: згорнути всі панелі',
  'editor.focusExit': 'Повернути панелі',
  'editor.panels': 'Панелі',
  'editor.timelineResize': 'Потягніть, щоб змінити висоту',
  'keys.nudge': 'Зсунути на 1 px',
  'keys.nudge10': 'Зсунути на 10 px',
  'keys.forward': 'Вище на один шар',
  'keys.backward': 'Нижче на один шар',
  'keys.front': 'На передній план',
  'keys.back': 'На задній план',
  'keys.hideShow': 'Сховати / показати',
  'keys.lockUnlock': 'Закріпити / відкріпити',
  'keys.keepRatio': 'Зберігати пропорції',
  'keys.rotateStep': 'Поворот із кроком 15°',
  'keys.distances': 'Відстані до сусідів',
  'keys.drag': 'тягнути',
  'keys.rotate': 'обертати',
  'keys.wheel': 'колесо',
  'keys.zoomWheel': 'Масштаб до курсора',
  'keys.pan': 'Рухати полотно',
  'keys.select': 'Виділення',
  'keys.body': 'Основний текст',
  'plan.from': 'Доступно з тарифу {plan}',
  'templates.placidFonts':
    'Не вдалося завантажити шрифти: {fonts}. Шари вже посилаються на них — завантажте файли шрифтів у розділі «Шрифти».',
  'templates.placidImages':
    '{n} зображень лишилися посиланнями на сховище Placid — їх не вдалося завантажити.',
  'templates.placidSkipped': 'Пропущено непідтримувані елементи: {types}',
  'templates.badJson': 'Файл не схожий на JSON',
  'err.placidFormat': 'Файл не схожий на експорт шаблону Placid',
  'consent.title': 'Ми використовуємо cookies',
  'consent.text':
    'Необхідні cookies тримають вас в акаунті. З вашої згоди ми також увімкнемо Google Analytics, щоб розуміти, як покращувати сервіс. Рекламних cookies немає.',
  'consent.accept': 'Прийняти всі',
  'consent.essentialOnly': 'Лише необхідні',
  'consent.customize': 'Налаштувати',
  'consent.save': 'Зберегти вибір',
  'consent.settingsTitle': 'Налаштування cookies',
  'consent.settingsText':
    'Оберіть, що дозволити. Змінити рішення можна будь-коли — посилання «Налаштування cookies» є внизу сайту та в профілі.',
  'consent.essential': 'Необхідні',
  'consent.essentialText':
    'Сесія входу, захист від підробки запитів, мова та вибраний простір. Без них сервіс не працює.',
  'consent.always': 'Завжди увімкнені',
  'consent.analytics': 'Аналітика (Google Analytics)',
  'consent.analyticsText':
    'Знеособлена статистика відвідувань: які сторінки відкривають і звідки приходять. Cookies _ga зберігаються до 2 років, дані в Google — 14 місяців.',
  'consent.more': 'Детальніше —',
  'consent.link': 'Налаштування cookies',
  'privacy.title': 'Конфіденційність і дані',
  'privacy.text': 'Завантажте копію своїх даних, змініть вибір cookies або видаліть акаунт.',
  'privacy.export': 'Завантажити мої дані',
  'privacy.delete': 'Видалити акаунт',
  'privacy.deleteTitle': 'Видалити акаунт назавжди?',
  'privacy.deleteText':
    'Акаунт, ваші дані та простори, якими користуєтеся лише ви (із шаблонами й файлами), буде видалено без можливості відновлення. Спершу можна завантажити копію даних.',
  'privacy.deleteConfirm': 'Видалити назавжди',
  'privacy.blocked': 'Спершу потрібно вирішити питання з просторами:',
  'privacy.blocker.transferOwnership':
    'ви єдиний власник, а там є учасники — призначте іншого власника',
  'privacy.blocker.cancelSubscription': 'активна підписка — скасуйте її в розділі «Тариф і оплата»',
  'privacy.willDelete': 'Буде видалено простори:',
  'privacy.willLeave': 'Ви залишите простори:',
  'privacy.typeEmail': 'Введіть {email} для підтвердження',
  'err.confirmEmail': 'Введіть свій email для підтвердження',
  'brandDs.sampleQuote': 'Запустили 300 банерів до розпродажу за вечір — і всі в нашому стилі.',
  'brandDs.sampleAuthor': 'Анна Коваль',
  'brandDs.sampleRole': 'Арт-директорка',
  'brandDs.sampleDate': '24 травня',
  'brandDs.samplePlace': 'Онлайн · 19:00',
  'brandDs.sampleNew': 'Новинка',
  'preview.fake': 'Випадкові дані',
  'preview.fakeRun': 'Випадково + рендер',
  'preview.fakeHint':
    'Тексти добираються за назвою шару (price, date, team, title…), фото — безкоштовні знімки Unsplash через Lorem Picsum, логотипи — DiceBear.',
  'gallery.cat.sport': 'Матчі й турніри',
  'fonts.cat.all': 'Усі',
  'fonts.cat.sans-serif': 'Гротески',
  'fonts.cat.serif': 'Із зарубками',
  'fonts.cat.display': 'Акцидентні',
  'fonts.cat.handwriting': 'Рукописні',
  'fonts.cat.monospace': 'Моно',
  'stock.myFiles': 'Мої файли',
  'stock.photos': 'Фото Unsplash',
  'stock.search': 'Пошук безкоштовних фото (краще англійською)',
  'stock.more': 'Ще фото',
  'stock.error': 'Не вдалося завантажити фото. Спробуйте пізніше.',
  'stock.credit':
    'Безкоштовні фото для комерційного використання, автор зазначається в описі шару. Джерело:',
  'stock.idea.coffee': 'coffee',
  'stock.idea.city': 'city night',
  'stock.idea.sport': 'football stadium',
  'stock.idea.food': 'food flat lay',
  'stock.idea.nature': 'mountains',
  'stock.idea.people': 'smiling woman',
  'err.stockOff': 'Пошук фото не налаштовано на сервері',
  'err.stockLimit': 'Досягнуто ліміту запитів Unsplash, спробуйте пізніше',
  'err.stockError': 'Unsplash повернув помилку, спробуйте пізніше',
  'motion.mode': 'Анімація',
  'motion.modeHint': 'Анімувати шаблон для відео, GIF і анімованих банерів',
  'motion.back': 'До дизайну',
  'motion.tabDesign': 'Дизайн',
  'motion.tabDesignHint':
    'Текст, шрифт, кольори й розміри шару — просто в анімації. Подвійний клік по тексту на сцені — редагувати його на місці',
  'motion.tabMotion': 'Анімація',
  'motion.sceneGraphics': 'Моушн-графіка сцени',
  'motion.sceneGraphicsHint': 'Відкрити в анімації та редагувати текст і параметри',
  'motion.play': 'Відтворити',
  'motion.pause': 'Пауза',
  'motion.animate': 'Оживити',
  'motion.animateHint':
    'Анімує всі шари у вибраному стилі. Ручні налаштування шарів буде замінено.',
  'motion.style': 'Стиль руху',
  'motion.clear': 'Прибрати анімацію',
  'motion.empty':
    'Шаблон поки статичний. Виберіть стиль і натисніть «Оживити» або налаштуйте кожен шар.',
  'motion.video': 'Відео',
  'motion.duration': 'Тривалість',
  'motion.fps': 'Кадрів/с',
  'motion.loops': 'Повтори банера',
  'motion.forever': 'Безкінечно',
  'motion.scenes': 'Сцени',
  'motion.scenesHint':
    'Сцени показуються по черзі, як кадри HTML5-банера. Шари без сцени видно весь час.',
  'motion.addScene': 'Додати сцену',
  'motion.sceneN': 'Сцена {n}',
  'motion.transition': 'Перехід',
  'motion.none': 'Немає',
  'motion.enter': 'Поява',
  'motion.emphasis': 'Акцент',
  'motion.exit': 'Зникнення',
  'motion.delay': 'Затримка',
  'motion.beforeEnd': 'До кінця',
  'motion.length': 'Довжина',
  'motion.easing': 'Крива',
  'motion.easingDefault': 'Як у пресеті',
  'motion.repeat': 'Повтори',
  'motion.repeatHint': '0 — до кінця сцени',
  'motion.gap': 'Пауза',
  'motion.split': 'Текст частинами',
  'motion.split_none': 'Цілком',
  'motion.split_line': 'Рядки',
  'motion.split_word': 'Слова',
  'motion.split_char': 'Літери',
  'motion.stagger': 'Крок',
  'motion.order': 'Порядок',
  'motion.order_start': 'З початку',
  'motion.order_end': 'З кінця',
  'motion.order_center': 'З центру',
  'motion.order_edges': 'З країв',
  'motion.order_random': 'Урозкид',
  'motion.scene': 'Сцена',
  'motion.wholeVideo': 'Усе відео',
  'motion.layerHint': 'Виберіть шар у списку або на таймлайні, щоб налаштувати його рух.',
  'motion.dir_up': 'Вгору',
  'motion.dir_down': 'Вниз',
  'motion.dir_left': 'Ліворуч',
  'motion.dir_right': 'Праворуч',
  'motion.sec': 'с',
  'motion.opener': 'Початок',
  'motion.layerStyle': 'Рух шарів',
  'motion.noOpener': 'Без опенера',
  'motion.pickHint':
    'Опенер, рух шарів, акценти й кінцівка доповнюють одне одного: вибір одразу застосовується.',
  'motion.openerPickHint':
    'Графіка на початку ролика, поверх вашого дизайну. Наведіть, щоб програти.',
  'motion.stylePickHint': 'Як зʼявляються й живуть шари вашого дизайну. Наведіть, щоб програти.',
  'motion.outro': 'Кінцівка',
  'motion.noOutro': 'Без кінцівки',
  'motion.outroPickHint':
    'Чим закінчується ролик: картка із закликом, фокус на пропозиції, петля. Наведіть, щоб програти.',
  'motion.accents': 'Акценти',
  'motion.accentsHint':
    'Моменти в середині ролика, привʼязані до елементів. Без потрібного елемента акцент нічого не робить.',
  'motion.customBadge': 'Ваш',
  'motion.deletePresetTitle': 'Видалити пресет?',
  'motion.deletePresetText':
    'Пресет зникне зі списків. Шаблони, вже анімовані ним, не зміняться: у них своя копія.',
  'motion.soundBarHint':
    'Тягніть, щоб зсунути; краї — обрізати початок і кінець; з Shift — зсунути звук усередині відрізка; Alt — без прив’язки до долей',
  'motion.splitSound': 'Розрізати',
  'motion.splitSoundHint': 'Розрізати звук по плейхеду (S)',
  'motion.splitSoundOutside': 'Поставте плейхед усередину вибраного звуку',
  'motion.removeSound': 'Видалити звук',
  'motion.oneScene': 'одна',
  'admin.settings': 'Налаштування',
  'admin.settingsSaved': 'Збережено',
  'backup.tab': 'Перенесення сервера',
  'backup.exportTitle': 'Завантажити бекап',
  'backup.exportText':
    'Один ZIP з усією базою (користувачі, простори, шаблони, автоматизації, інтеграції, історія) і всіма файлами. Завантажте його в адмінці нового сервера.',
  'backup.includeFiles': 'З файлами (зніміть, якщо обидва сервери використовують одне S3-сховище)',
  'backup.download': 'Завантажити бекап',
  'backup.importTitle': 'Відновити з бекапу',
  'backup.importText':
    'Замінює всі дані цього сервера даними з бекапу. Версія Bannermatic і ENCRYPTION_KEY мають збігатися зі старим сервером. Акаунти й сесії переїжджають разом із базою.',
  'backup.chooseFile': 'Вибрати ZIP',
  'backup.restore': 'Відновити',
  'backup.confirmTitle': 'Замінити всі дані цього сервера?',
  'backup.confirmText':
    'Усі користувачі, шаблони й налаштування тут буде замінено даними з бекапу. Скасувати це не можна.',
  'backup.keyHint':
    'ENCRYPTION_KEY тут інший: підключені Google-акаунти, S3 та інші секрети не відкриються. Краще скопіюйте ENCRYPTION_KEY зі старого сервера й перезапустіть цей.',
  'backup.ignoreKey': 'Все одно відновити (інтеграції доведеться підключити заново)',
  'backup.restored':
    'Відновлено: користувачів {users}, файлів {files}. Якщо попросить увійти — використайте акаунт зі старого сервера.',
  'err.backupInvalid': 'Це не бекап Bannermatic.',
  'err.backupVersion':
    'Бекап зроблено іншою версією Bannermatic. Спершу оновіть обидва сервери до однієї версії.',
  'err.backupKey': 'ENCRYPTION_KEY відрізняється від старого сервера.',
  'admin.serverVideo': 'Рендер відео на сервері',
  'admin.serverVideoPlans': 'Тарифи, яким можна рендерити відео на сервері',
  'admin.serverVideoPlansHint':
    'Решта тарифів робить відео лише в браузері користувача, навіть якщо рендер на сервері увімкнено.',
  'admin.serverVideoOffHint':
    "Вимкнено для всіх. Відео (MP4, WebM, GIF) рендеряться лише на комп'ютері користувача в редакторі. API та автоматизації з відеоформатами отримують помилку, картинки працюють як зазвичай.",
  'admin.serverVideoOnHint':
    'Увімкнено для всіх. Відео рендеряться на ваших серверах: з редактора, API та автоматизацій. Один ролик 5 с 1080×1080 займає близько 20 vCPU·с.',
  'browserRender.serverOffNoDevice':
    "Відео зараз рендеряться лише на комп'ютері користувача, а цей браузер так не вміє. Відкрийте редактор у Chrome або Edge на комп'ютері.",
  'automation.serverVideoOff':
    'Відеоформати недоступні: рендер відео на сервері зараз вимкнено. Відео можна зробити в редакторі кнопкою «Згенерувати».',
  'err.serverVideoOff':
    "Рендер відео на сервері вимкнено. Зробіть відео в редакторі: «Згенерувати» → на цьому комп'ютері.",
  'resize.videoFormats': 'Формати для соцмереж',
  'motion.easingHint':
    'Як змінюється швидкість руху: по горизонталі час, по вертикалі шлях. Наведіть, щоб побачити.',
  'video.galleryHint':
    'Готові рекламні ролики зі сценами, переходами й монтажем. Наведіть на картку, щоб переглянути, оберіть формат і замініть фото й тексти на свої.',
  'video.hoverToPlay': 'Наведіть, щоб відтворити',
  'video.cat.basic': 'Базові структури',
  'video.cat.sale': 'Розпродажі',
  'video.cat.product': 'Товар',
  'video.cat.fashion': 'Мода',
  'video.cat.food': 'Їжа',
  'video.cat.realestate': 'Нерухомість',
  'video.cat.travel': 'Подорожі',
  'video.cat.fitness': 'Фітнес',
  'video.cat.event': 'Події',
  'video.cat.tech': 'Застосунки та IT',
  'video.cat.beauty': 'Краса',
  'video.cat.auto': 'Авто',
  'video.cat.hiring': 'Вакансії',
  'video.cat.holiday': 'Свята',
  'video.cat.social': 'Соцмережі й відгуки',
  'video.cat.motion': 'Моушн-дизайн',
  'api.videoHelp':
    'ролики й анімовані шаблони (рендер довший, зручніше з ?wait=false і webhook_url). У шар із фото можна передати посилання на відео .mp4/.mov/.webm, обрізка: video_start, video_end (с), video_speed, video_muted.',
  'api.motionStyleHelp':
    'анімувати шаблон стилем (smooth, energetic, elegant, kinetic, sale…); без нього використовується анімація шаблону.',
  'api.soundHelp':
    'музика й озвучка ролика: посилання на файл, null, щоб прибрати, або { url, volume, start, fade_out }.',
  'automation.videoFormatsHint':
    'MP4, WEBM і GIF рендерять ролики та анімацію. Статичний шаблон отримає плавну анімацію автоматично.',
  'motion.zoom': 'Масштаб таймлайну',
  'motion.zoomIn': 'Наблизити',
  'motion.zoomOut': 'Віддалити',
  'motion.zoomFit': 'Весь ролик',
  'motion.zoomHint': 'Масштаб: Ctrl + коліщатко миші. Зсув убік: Shift + коліщатко',
  'templates.filterBanners': 'Банери',
  'templates.filterVideos': 'Ролики',
  'templates.kindVideo': 'Ролик',
  'templates.kindAnimated': 'Анімація',
  'templates.scenes': 'сцен: {n}',
  'story.openHint': 'Клік: перейти до сцени. Подвійний клік або олівець: відкрити її в дизайні',
  'story.editDesign': 'Змінити дизайн сцени',
  'sound.micInsecure':
    'Браузер дає мікрофон лише сайтам на https або localhost. Відкрийте редактор за https-адресою.',
  'sound.micMissing': 'Мікрофон не знайдено. Підключіть його і спробуйте ще раз.',
  'video.new': 'Новий ролик',
  'video.fmt.vertical': 'Reels, TikTok, Shorts',
  'video.fmt.portrait': 'Стрічка, 4:5',
  'video.fmt.square': 'Квадрат',
  'video.fmt.wide': 'YouTube, сайт',
  'video.recipe.sale': 'Розпродаж',
  'video.recipe.saleHint': 'Гачок, товар, ціна зі знижкою, заклик',
  'video.recipe.launch': 'Новинка',
  'video.recipe.launchHint': 'Гачок, товар, три переваги, заклик',
  'video.recipe.review': 'Відгук',
  'video.recipe.reviewHint': 'Цитата покупця, товар, переваги, заклик',
  'video.recipe.event': 'Анонс',
  'video.recipe.eventHint': 'Гачок, дата й місце, що буде, заклик',
  'video.scene.hook': 'Гачок',
  'video.scene.product': 'Товар',
  'video.scene.offer': 'Ціна',
  'video.scene.benefits': 'Переваги',
  'video.scene.quote': 'Відгук',
  'video.scene.when': 'Коли й де',
  'video.scene.cta': 'Заклик',
  'video.txt.hook.sale': 'Лише 3 дні!',
  'video.txt.hook.launch': 'Зустрічайте новинку',
  'video.txt.hook.event': 'Не пропустіть!',
  'video.txt.product': 'Назва товару',
  'video.txt.oldPrice': '1 990 ₴',
  'video.txt.price': '990 ₴',
  'video.txt.benefit1': 'Безкоштовна доставка',
  'video.txt.benefit2': 'Легке повернення',
  'video.txt.benefit3': 'Нас обрали 10 000+ клієнтів',
  'video.txt.quote': '«Найкраща покупка року»',
  'video.txt.author': 'Анна, покупниця',
  'video.txt.date': '12 червня · 19:00',
  'video.txt.place': 'Онлайн',
  'video.txt.cta.sale': 'Купити зі знижкою',
  'video.txt.cta.launch': 'Дізнатися більше',
  'video.txt.cta.review': 'Спробувати',
  'video.txt.cta.event': 'Зареєструватися',
  'safe.hint': 'Безпечні зони: де застосунок закриває відео кнопками й підписом',
  'safe.off': 'Без зон',
  'safe.zone': 'Зони {app}',
  'sound.title': 'Голос і звуки',
  'sound.record': 'Записати голос',
  'sound.stop': 'Стоп',
  'sound.upload': 'Завантажити аудіо',
  'sound.hint':
    'Закадровий голос, ефекти, друга мелодія. Стають з позиції курсора, музика приглушується під голос.',
  'sound.recordingHint': 'Йде запис під відео. Краще в навушниках, щоб мікрофон не ловив музику.',
  'sound.micDenied':
    'Немає доступу до мікрофона. Натисніть на значок замка ліворуч від адреси сайту, дозвольте мікрофон і спробуйте ще раз.',
  'sound.start': 'Початок',
  'sound.here': 'До курсора',
  'sound.toPlayhead': 'Поставити початок на позицію курсора',
  'sound.duck': 'Музика під голосом',
  'sound.kind.voice': 'Голос',
  'sound.kind.music': 'Музика',
  'sound.kind.sfx': 'Ефект',
  'editor.videoSpeed': 'Швидкість',
  'editor.videoFitScene': 'Сцена за довжиною кліпу ({s} с)',
  'story.title': 'Розкадровка',
  'story.emptyHint': 'Розбийте ролик на сцени: гачок, товар, переваги, оффер, заклик.',
  'story.make': 'Розбити на сцени',
  'story.add': 'Сцена',
  'story.split': 'Розрізати тут',
  'story.addAfter': 'Нова сцена після цієї',
  'story.moveEarlier': 'Перемістити раніше',
  'story.moveLater': 'Перемістити пізніше',
  'story.cut': 'Склейка',
  'story.toAll': 'Показувати в усіх сценах',
  'story.toScene': 'В усіх сценах. Натисніть, щоб залишити лише в цій',
  'err.browserRenderPlan': "Рендер на своєму комп'ютері недоступний на цьому тарифі.",
  'billing.fVideo': 'Відео: {n} хв на місяць ({m} хв на вашому комп’ютері)',
  'billing.videoPeriod': 'Відео в поточному періоді',
  'billing.videoMin': '{n} хв',
  'err.videoLimit':
    'Місячний ліміт відео вичерпано ({used} з {limit} с на тарифі {plan}). Рендер на вашому комп’ютері витрачає ліміт у 4 рази повільніше.',
  'browserRender.optionHint':
    'Відео малюється й кодується у вашому браузері. Витрачає в 4 рази менше ліміту відео, ніж рендер на сервері.',
  'preview.deviceFree':
    'Дешевше: рендер на вашому комп’ютері витрачає в 4 рази менше ліміту відео.',
  'videoGen.title': 'Ролик з вашого контенту',
  'videoGen.hint': 'ваші тексти, фото й бренд — щоразу нові ролики',
  'videoGen.headline': 'Заголовок',
  'videoGen.brandName': 'Назва бренду чи товару',
  'videoGen.subline': 'Підзаголовок',
  'videoGen.benefits': 'Переваги',
  'videoGen.perLine': 'По одному в рядку, до 5',
  'videoGen.stats': 'Цифри',
  'videoGen.statsHint': '«12k — підписників», по одній у рядку',
  'videoGen.more': 'Пропозиція, ціна, відгук, кнопка',
  'videoGen.offer': 'Пропозиція (−30%, 2 за ціною 1)',
  'videoGen.offerNote': 'Підпис до пропозиції',
  'videoGen.price': 'Ціна',
  'videoGen.oldPrice': 'Стара ціна',
  'videoGen.quote': 'Відгук',
  'videoGen.author': 'Автор відгуку',
  'videoGen.cta': 'Текст кнопки',
  'videoGen.site': 'Сайт або акаунт',
  'videoGen.brandKit': 'Брендкіт',
  'videoGen.brandKitHint': 'Кольори, шрифти й логотип бренду',
  'videoGen.noBrand': 'Без бренду — випадкова палітра',
  'videoGen.logo': 'Логотип',
  'videoGen.noLogo': 'Без логотипа',
  'videoGen.logoBrand': 'З брендкіту',
  'videoGen.photos': 'Фото',
  'videoGen.photosHint': 'вибрано {n} · з медіатеки або завантажте свої',
  'videoGen.generate': 'Згенерувати ролики',
  'videoGen.again': 'Ще варіанти',
  'videoGen.needHeadline': 'Потрібен заголовок',
  'videoGen.variant': 'варіант {n}',
  'browserRender.option': "На цьому комп'ютері (бета)",
  'browserRender.title': "Рендер на цьому комп'ютері",
  'browserRender.prepare': 'Готую сцену…',
  'browserRender.sound': 'Зводжу звук…',
  'browserRender.frames': 'Кадр {n} з {total}',
  'browserRender.paused': 'Пауза: вкладку приховано. Поверніться на неї, і рендер продовжиться.',
  'browserRender.finish': 'Зберігаю відео…',
  'browserRender.keepOpen': 'Не закривайте й не згортайте вкладку, поки йде рендер.',
  'browserRender.speed': "Швидкість залежить від вашого комп'ютера.",
  'browserRender.differs': 'Результат може трохи відрізнятися від рендера на сервері.',
  'browserRender.cancelled': 'Рендер скасовано',
  'motion.music': 'Музика',
  'motion.noMusic': 'Без музики',
  'motion.musicUpload': 'Завантажити трек (MP3, M4A, WAV, OGG, FLAC)',
  'motion.musicHint':
    'Завантажте трек, і ми знайдемо його темп: «Оживити» поставить рухи в такт, а звук потрапить у MP4 і WEBM.',
  'motion.musicStart': 'Відступ у треку',
  'motion.musicAt': 'Початок',
  'motion.musicAtHint': 'Коли музика починає грати в ролику',
  'motion.musicLength': 'Довжина',
  'motion.musicLengthHint': 'Скільки грає музика. До кінця ролика — подовжується разом із роликом',
  'motion.bpmHint':
    'Темп треку, ударів за хвилину. Знайдено автоматично, можна виправити; 0 вимикає сітку.',
  'motion.fadeIn': 'Поява',
  'motion.fadeOut': 'Згасання',
  'motion.beatSync': '«Оживити» в такт музиці',
  'motion.syncNow': 'Підігнати під біт',
  'motion.noBeat': 'У треку не знайшлося рівного ритму. Вкажіть BPM вручну, якщо він є.',
  'err.audioUnreadable': 'Не вдалося прочитати аудіо: завантажте MP3, M4A, WAV, OGG або FLAC.',
  'motion.beats': 'Біти',
  'motion.keys': 'Ключові кадри',
  'motion.keysHint':
    'Поставте плейхед і перетягніть шар на сцені, кадр запишеться. Перетягніть в інший момент, і шар поїде між ними.',
  'motion.keyScale': 'Масштаб',
  'motion.keyRotate': 'Поворот',
  'motion.keyOpacity': 'Видимість',
  'motion.keyEasing': 'До наступного',
  'motion.keyDelete': 'Видалити кадр',
  'motion.keyAdd': 'Кадр тут',
  'motion.keysClear': 'Прибрати всі',
  'motion.openers': 'Опенери',
  'motion.styles': 'Стилі руху шарів',
  'motion.fx': 'Графіка',
  'motion.fxHint':
    'Панелі, кола, конфеті, титри й фони над або під дизайном. Кольори беруться з шаблону.',
  'motion.addFx': '+ Додати графіку',
  'motion.camera': 'Камера',
  'motion.cameraHint': 'Рухи всієї композиції: наїзд, відʼїзд, струс, панорама.',
  'motion.addCamera': '+ Додати рух камери',
  'motion.start': 'Початок',
  'motion.zLayer': 'Де',
  'motion.zFront': 'Над дизайном',
  'motion.zBack': 'Під шарами (фон)',
  'motion.auto': 'Автоматично',
  'motion.color_accent': 'Акцент шаблону',
  'motion.color_accent2': 'Другий акцент',
  'motion.color_dark': 'Темний',
  'motion.color_light': 'Світлий',
  'motion.color_ink': 'Контраст до фону',
  'motion.color_custom': 'Свій колір',
  'motion.fxcat_text': 'Титри',
  'motion.fxcat_cover': 'Перекриття',
  'motion.fxcat_accent': 'Акценти',
  'motion.fxcat_ambient': 'Фони',
  'motion.keyBlur': 'Розмиття',
  'sound.auto': 'Озвучити автоматично',
  'sound.autoAgain': 'Перерахувати ефекти',
  'sound.autoClear': 'Прибрати автоефекти',
  'sound.autoHint':
    'Вжух за 0,4 с до переходу, удар на склейці, тік на кожну літеру, що приземлилась, друк для термінала тощо. Ваші звуки не змінюються.',
  'sound.addSfx': 'Ефект',
  'sound.generateMusic': 'Згенерувати музику',
  'sound.listen': 'Послухати варіант',
  'sound.anotherTake': 'Інший варіант',
  'sound.useTake': 'У відео',
  'sound.bpmAuto': '0 — темп добирає стиль',
  'sound.energy_calm': 'Спокійно',
  'sound.energy_normal': 'Звичайно',
  'sound.energy_high': 'Потужно',
  'sound.generateMusicHint':
    'Кожен варіант — нова пʼєса: тональність, грув, бас, мелодія, вступ, дроп і брейк; тарілки лягають на склейки відео. Без авторських прав.',
  'motion.fontAuto': 'Як у шару чи заголовка',
  'motion.fontReset': 'Скинути шрифт',
  'motion.textFx': 'Текстовий ефект',
  'motion.textFxHint':
    'Ефект стає частиною цього шару: той самий текст, шрифт і колір, шар просто грає по-новому. Смуга ефекту — на рядку шару в стрічці.',
  'motion.textFxApply': 'Застосувати',
  'motion.poster': 'Обкладинка (превʼю й картинка)',
  'motion.textFxUntilEnd': '0 — поки шар на екрані',
  'motion.textFxRemove': 'Прибрати ефект',
  'motion.generator': 'Генератор руху',
  'motion.generatorHint':
    'Траєкторії, фізика й шум записуються ключами від плейхеда — їх можна правити по одному.',
  'motion.genDistance': 'Розмах',
  'motion.genAngle': 'Кут',
  'motion.genGrow': 'Ріст, %',
  'motion.genCycles': 'Цикли',
  'motion.genLength': 'Довжина',
  'motion.genDirection': 'Куди',
  'motion.genOrient': 'Повертати за траєкторією',
  'motion.genApply': 'Записати ключі',
  'motion.repeater': 'Розмножити шар',
  'motion.repeaterHint':
    'Копії сіткою, по колу, лінією, спіраллю чи розсипом, кожна стартує трохи пізніше.',
  'motion.repeatLayout': 'Розкладка',
  'motion.repeat_grid': 'Сітка',
  'motion.repeat_circle': 'Коло',
  'motion.repeat_line': 'Лінія',
  'motion.repeat_spiral': 'Спіраль',
  'motion.repeat_scatter': 'Розсип',
  'motion.repeatCount': 'Скільки',
  'motion.repeatCols': 'У ряд',
  'motion.repeatRadius': 'Радіус',
  'motion.repeatAngle': 'Кут',
  'motion.repeatGap': 'Проміжок',
  'motion.repeatStagger': 'Крок',
  'motion.repeatRotate': 'Поворот',
  'motion.repeatScale': 'Розмір',
  'motion.repeatOpacity': 'Прозорість',
  'motion.repeatOrient': 'Повертати назовні',
  'motion.repeatApply': 'Створити копії ({n})',
  'motion.fxcat_interface': 'Інтерфейс і дані',
  'motion.fxcat_pattern': 'Патерни й частинки',
  'motion.cost': 'Відео рендериться довше за картинку, зазвичай 10–30 секунд.',
};
